{
  "es": {
    "labels": {
      "saved": "Guardado",
      "hangarShare": {
        "intro": "Crea un enlace secreto que muestra tu hangar y sus estadísticas a quien se lo des, incluso mientras tu hangar es privado. Tu lista de deseos mantiene su propia configuración.",
        "howTo": "Cualquiera con este enlace puede ver tu hangar. Renuévalo para bloquear a todos los que tengan el enlace actual, o elimínalo para dejar de compartir."
      },
      "locationInput": {
        "linked": "Vinculado a"
      },
      "galactapedia": "Galactapedia",
      "shopPage": {
        "all": "Todo",
        "search": "Buscar en esta tienda",
        "categories": "Categorías",
        "sortName": "Nombre",
        "sortPrice": "Precio",
        "emptyName": "artículo",
        "kind": "Tienda",
        "items": "Artículos",
        "facts": "Datos clave",
        "place": "Lugar",
        "system": "Sistema",
        "carries": "Vende",
        "source": "Precios y existencias de UEX."
      },
      "location": {
        "missionsSample": "Los recuentos cubren los primeros %{shown} de %{total}.",
        "people": "Amigos y flota aquí",
        "peopleFriend": "Amigo",
        "peopleUnlisted": "%{count} más sin listar",
        "systemUnavailable": "No se pudo cargar este sistema.",
        "systemsUnavailable": "No se pudieron cargar los sistemas.",
        "resourceKinds": {
          "ship_mineables": "Minables con nave",
          "hand_mineables": "Minables a mano",
          "ground_vehicle_mineables": "Minables con vehículo terrestre",
          "harvestables": "Recolectables",
          "creatures": "Criaturas"
        },
        "resources": "Recursos",
        "moonsBadge": "Lunas",
        "planets": "Planetas",
        "places": "Lugares",
        "showFewer": "Mostrar menos",
        "showAll": "Mostrar los %{count}",
        "elsewhere": "En otros lugares alrededor de %{star}",
        "namesakes": "×%{count}",
        "lagrangePoints": "Puntos de Lagrange",
        "inOrbit": "En órbita",
        "moons": {
          "one": "%{count} luna",
          "other": "%{count} lunas"
        },
        "gateways": "Portales de salto",
        "jumpPoints": "Puntos de salto",
        "notInGameYet": "Aún no está en el juego",
        "jumpLegend": {
          "title": "Conexiones de salto",
          "inGame": "En el juego",
          "temporary": "Temporal",
          "planned": "Planeado"
        },
        "systemStrip": "%{system}, desde su estrella hacia fuera",
        "allSystems": "Todos los sistemas",
        "allPlaces": "Todos los lugares",
        "shops": "Tiendas",
        "shopItems": {
          "one": "%{count} artículo",
          "other": "%{count} artículos"
        },
        "shopItemTypes": {
          "Model": "Nave",
          "ModelModule": "Módulo",
          "ModelPaint": "Pintura",
          "Component": "Componente",
          "Equipment": "Equipo",
          "Commodity": "Mercancía"
        },
        "bodyTypes": {
          "gas_giant": "Gigante gaseoso",
          "ice_giant": "Gigante helado",
          "asteroid": "Asteroide",
          "city": "Planeta ciudad"
        },
        "unstable": "Inestable",
        "unstableHint": "Una estrella fulgurante: su emisión se dispara sin aviso.",
        "systems": "Sistemas estelares",
        "name": "Nombre",
        "kind": "Tipo",
        "retired": "No está en esta versión",
        "starmap": "Mapa estelar",
        "starmapVisibility": "Mapa del juego",
        "starmapHidden": "Oculto en el mapa",
        "starmapAlways": "Siempre visible en el mapa",
        "starmapWithParent": "Visible al seleccionar %{parent}",
        "starmapShown": "Visible en el mapa",
        "quantumTravel": "Viaje cuántico",
        "quantumTravelYes": "Sí",
        "quantumTravelNo": "No",
        "mapParent": "Dibujado bajo",
        "mapParentNote": "El mapa del juego lo dibuja bajo %{mapParent}, aunque está dentro de %{parent}.",
        "missions": "Misiones",
        "allMissions": "Todas las misiones que pueden tener lugar aquí",
        "terminals": "Terminales comerciales",
        "alwaysShown": "Siempre en el mapa",
        "hiddenOnStarmap": "Oculto en el mapa",
        "facilities": "Aterrizaje",
        "hangars": "Hangares",
        "hangarsNote": "Cada hangar es una instancia por piloto: se cuentan puertas, no plazas.",
        "landingPads": "Plataformas de aterrizaje",
        "freeLandingPads": "Plataformas de aterrizaje libres",
        "freeLandingPadsNote": "Aterriza sin que el ATC asigne la plataforma.",
        "vehiclePads": "Plataformas para vehículos terrestres",
        "dockingTubes": "Anillos de atraque",
        "kinds": {
          "system": "Sistema estelar",
          "star": "Estrella",
          "planet": "Planeta",
          "moon": "Luna",
          "city": "Ciudad",
          "spaceport": "Puerto espacial",
          "station": "Estación",
          "outpost": "Puesto avanzado",
          "clinic": "Clínica",
          "district": "Distrito",
          "asteroid": "Asteroide",
          "anomaly": "Anomalía",
          "jump_point": "Punto de salto",
          "point_of_interest": "Punto de interés",
          "nav_point": "Punto de navegación",
          "other": "Otro"
        },
        "setLocation": "Establecer ubicación",
        "myLocation": "Mi ubicación",
        "shipLocation": "Ubicación de una nave",
        "setLocationSuccess": "Ubicación actualizada.",
        "setLocationFailure": "No se pudo actualizar la ubicación."
      },
      "sortOptions": "Opciones de orden",
      "loading": "Cargando…",
      "loadingNamed": "Cargando %{name}…",
      "true": "Sí",
      "false": "No",
      "null": "-",
      "presets": {
        "title": "Elegir una imagen",
        "filter": "Tipo",
        "all": "Todas",
        "empty": "No hay imágenes disponibles."
      },
      "maintainer": {
        "badge": "Mantenedor",
        "tooltip": "Mantiene FleetYards.net"
      },
      "supporter": {
        "badge": "Patrocinador",
        "tooltip": "Apoya a FleetYards.net este mes",
        "none": "No es colaborador",
        "fleetTierUntil": "Nivel de flota hasta el %{date}",
        "fleetTierExpired": "Caducado",
        "fleetTierOngoing": "Nivel de flota mientras siga la suscripción",
        "until": "Activo hasta el %{date}",
        "expiring": "Caduca el %{date}",
        "ongoing": "Recurrente, sin fecha de fin",
        "tierShort": "Nivel %{tier}"
      },
      "destroyedFleets": {
        "discarded": "Descartada",
        "purged": "Purgada"
      },
      "and": "y",
      "hide": "Ocultar",
      "show": "Mostrar",
      "only": "Solo",
      "description": "Descripción",
      "unavailable": "no disponible",
      "selected": "Seleccionado",
      "actions": "Acciones",
      "status": "Estado",
      "enabled": "Habilitado",
      "disabled": "Deshabilitado",
      "collapse": "Contraer",
      "price": "Precio",
      "expand": "Expandir",
      "distance": "Distancia",
      "anonymous": "Anónimo",
      "refreshing": "Actualizando...",
      "toggleNavigation": "Alternar navegación",
      "openInNewWindow": "Abrir en pantalla completa",
      "or": "o",
      "groups": "Grupos",
      "classifications": "Clasificaciones",
      "features": {
        "stateOn": "Habilitado",
        "stateOff": "Deshabilitado",
        "stateConditional": "Condicional",
        "openFor": "Abierto desde hace %{days} días",
        "historyEmpty": "Todavía no se ha registrado nada para esta función.",
        "historyBy": "por %{actor}",
        "sources": {
          "admin": "Administración",
          "self_service": "Autoservicio",
          "sync": "Despliegue",
          "console": "Consola",
          "backfill": "Rellenado"
        },
        "selfService": "Autoservicio",
        "actors": "Actores",
        "groups": "Grupos",
        "noGroups": "No hay grupos habilitados para esta función.",
        "noActors": "No hay actores individuales habilitados para esta función.",
        "user": "Usuario",
        "fleet": "Flota",
        "actorType": "Tipo de actor",
        "percentageOfActors": "de actores",
        "percentageOfTime": "del tiempo",
        "currentState": "Estado actual",
        "toggle": "Alternar",
        "permanent": "Permanente",
        "tabs": {
          "all": "Todas",
          "rollout": "Despliegue",
          "permanent": "Permanentes"
        },
        "settingsIntro": "Habilite o deshabilite funciones experimentales para su cuenta. Estas funciones pueden estar incompletas o cambiar sin previo aviso.",
        "registryHint": "Los flags se declaran en config/feature_flags.yml y se crean al desplegar. Aquí controlas sus puertas de acceso.",
        "fleetSettingsIntro": "Habilite o deshabilite funciones para toda la flota. Todos los miembros ven lo que active aquí.",
        "fleetFeature": "Función de flota",
        "fleetFeatureInfo": "Activarla aquí la habilita solo para usted. Los administradores de su flota pueden habilitarla para toda la flota.",
        "toggleForSelf": "Activar solo para usted",
        "fleetFeatureGrantedShort": "Activado por la flota",
        "fleetFeatureGranted": "Su flota lo activó para todos los miembros, por lo que no se puede desactivar aquí.",
        "groupFeatureGrantedShort": "Activado por el grupo",
        "groupFeatureGranted": "Un grupo al que pertenece tiene esta función activada, por lo que no se puede desactivar aquí.",
        "groupFeatureGrantedFleet": "Un grupo al que pertenece esta flota tiene esta función activada, por lo que no se puede desactivar aquí.",
        "managedFeatureShort": "Gestionado",
        "managedFeature": "Esta función se activó para su cuenta y no se puede cambiar aquí.",
        "managedFeatureFleet": "Esta función se activó para esta flota y no se puede cambiar aquí.",
        "selfServiceUser": "Los usuarios pueden alternar",
        "selfServiceFleet": "Los admins de flota pueden alternar",
        "globalHint": "Activada, la función queda abierta para todos. Desactivada, se borran todas las reglas, incluidos los usuarios, flotas y grupos de abajo.",
        "selfServiceHint": "Quién puede activar esta función por su cuenta.",
        "lastChanged": "Último cambio: %{date}",
        "filterUsers": "Filtrar por nombre de usuario",
        "filterFleets": "Filtrar por nombre o SID",
        "noUsers": "Ningún usuario tiene esta función habilitada individualmente.",
        "noFleets": "Ninguna flota tiene esta función habilitada individualmente.",
        "noMatches": "Nada coincide con el filtro.",
        "memberCount": "%{count} miembros",
        "alreadyEnabled": "Esta flota ya tiene la función."
      },
      "oauthApplication": {
        "name": "Nombre de la aplicación",
        "clientId": "ID de cliente",
        "clientSecret": "Secreto de cliente",
        "redirectUri": "URI de redirección",
        "redirectUriHint": "Use una URI por línea.",
        "confidential": "Confidencial",
        "scopes": "Alcances",
        "scopesHint": "Si no se seleccionan alcances, se usarán los alcances predeterminados: %{scopes}",
        "logo": "Logotipo",
        "logoHint": "Se muestra en la pantalla de consentimiento para que la gente reconozca tu aplicación. PNG, JPG, GIF o WebP."
      },
      "rsiRequestLogs": {
        "resolved": "Resuelto",
        "unresolved": "Sin resolver"
      },
      "imports": {
        "type": "Tipo",
        "status": "Estado",
        "version": "Versión",
        "startedAt": "Iniciada",
        "finishedAt": "Finalizada",
        "failedAt": "Falló el",
        "info": "Info",
        "input": "Entrada",
        "output": "Salida",
        "importData": "Datos de importación",
        "file": "Archivo importado",
        "requestedBy": "Solicitada por",
        "adminUser": "Usuario administrador",
        "user": "Usuario",
        "includeSystem": "Incluir sistema",
        "systemRequester": "sistema",
        "statuses": {
          "created": "En cola",
          "started": "En ejecución",
          "finished": "Finalizada",
          "failed": "Fallida",
          "cancelled": "Cancelado"
        },
        "targetGroupHint": "Elige un grupo de hangar y cada nave importada se archivará allí. Déjalo vacío para usar los grupos indicados en el archivo.",
        "types": {
          "Imports::HangarImport": "Importación de hangar",
          "Imports::HangarSync": "Sincronización de hangar RSI"
        },
        "summary": {
          "imported": "Importadas",
          "missing": "No encontradas",
          "found": "Coincidentes"
        },
        "formatHint": "Se aceptan dos formatos de archivo:",
        "formats": {
          "fleetyards": "Una exportación de hangar de FleetYards: usa el botón Exportar para crearla.",
          "hangarXplor": "Una exportación de hangarXPLOR."
        },
        "details": {
          "imported": "Añadidas",
          "found": "Coincidentes",
          "movedToWanted": "Movidas a la lista de deseos",
          "deleted": "Eliminadas",
          "grouped": "Archivadas en un grupo",
          "unchanged": "Sin cambios",
          "missing": "Naves no encontradas",
          "missingComponents": "Componentes no encontrados",
          "missingUpgrades": "Mejoras no encontradas"
        },
        "noDetails": "Esta ejecución no registró detalles."
      },
      "oauthApplications": {
        "settingsIntro": "Administre sus aplicaciones OAuth. Estas aplicaciones pueden acceder a la API de FleetYards en nombre de los usuarios.",
        "name": "Nombre de la aplicación",
        "redirectUri": "URI de redirección",
        "confidential": "Confidencial",
        "clientId": "ID de cliente",
        "clientSecret": "Secreto de cliente",
        "scopes": "Alcances",
        "defaultScopes": "Alcances predeterminados",
        "confidentialShort": "Confidencial",
        "publicShort": "Público",
        "logo": "Logotipo",
        "state": "Estado",
        "rejectionReason": "Motivo del rechazo",
        "statePending": "Pendiente de revisión",
        "stateApproved": "Aprobada",
        "stateRejected": "Rechazada",
        "reviewedBy": "Revisada por",
        "owner": "Registrada por"
      },
      "fleetInviteToken": "Invitación de flota",
      "inviteToken": "Código de invitación",
      "scDataVersion": "Versión del parche",
      "title": "Título",
      "createdAt": "Creado el",
      "updatedAt": "Actualizado el",
      "addToHangar": "Agregar al hangar",
      "home": {
        "search": "Buscar naves..."
      },
      "shop": {
        "sellPrice": "vende por",
        "buyPrice": "compra por"
      },
      "shopCommodity": {
        "item": "Artículo",
        "shop": "Tienda",
        "buyPrices": "Precios de compra",
        "rentalPrices": "Precios de alquiler",
        "confirmed": "¿Confirmado?",
        "prices": {
          "label": "Precios",
          "sellPrice": "vende por",
          "buyPrice": "compra por"
        }
      },
      "statsCard": {
        "more": "+%{count} más en la página de detalles",
        "unavailable": "No se pudieron cargar estos detalles.",
        "loading": "Cargando %{name}…",
        "offeredBy": "Ofrecida por %{name}",
        "rsiHandle": "Handle de RSI: %{handle}",
        "types": {
          "Component": "Componente",
          "Equipment": "Equipo",
          "Commodity": "Mercancía",
          "Model": "Nave",
          "Blueprint": "Plano",
          "GameMission": "Misión",
          "Location": "Lugar",
          "FleetContract": "Contrato",
          "FleetEvent": "Evento",
          "User": "Usuario",
          "FleetMember": "Miembro"
        },
        "open": {
          "Component": "Abrir componente",
          "Equipment": "Abrir equipo",
          "Commodity": "Abrir mercancía",
          "Model": "Abrir nave",
          "Blueprint": "Abrir plano",
          "GameMission": "Abrir misión",
          "Location": "Abrir lugar",
          "FleetContract": "Abrir contrato",
          "FleetEvent": "Abrir evento",
          "User": "Abrir hangar",
          "FleetMember": "Ver en la lista de miembros"
        }
      },
      "stats": {
        "quickStats": {
          "newShips": "Nuevas naves en %{year}",
          "totalShips": "Total de naves",
          "totalMembers": "Total de miembros",
          "vehicles": "Naves en hangar",
          "wishlists": "Naves en lista de deseos",
          "shipOfTheMonth": "Nave del mes"
        },
        "modelsByClassification": "Naves por clasificación",
        "modelsBySize": "Naves por tamaño",
        "vehiclesByModel": "Naves por modelo (Top %{limit})",
        "modelsPerMonth": "Naves por mes",
        "modelsByManufacturer": "Naves por fabricante",
        "modelsByProductionStatus": "Naves por estado de producción",
        "vehiclesPerMonth": "Naves en hangar por mes",
        "topVehiclesByModel": "Top 10 naves en hangar",
        "shipsOfTheMonth": "Nave del mes",
        "trendingShips": "Naves más vistas (30 días)",
        "wishlistByModel": "Naves más deseadas",
        "wishToOwnRatio": "Deseadas por 100 en posesión",
        "topPaints": "Pinturas más populares",
        "paintedVehicles": "Naves pintadas",
        "pledgePriceChanges": "Cambios de precio pledge (12 meses)",
        "ingamePriceChanges": "Cambios de precio en el juego (30 días)",
        "mostWishlisted": "Naves más deseadas este mes",
        "patchChanges": "Más modificadas por este parche",
        "crewDeficit": "Déficit de tripulación",
        "crewSurplus": "Excedente de tripulación",
        "membersByRole": "Miembros por rol",
        "csv": {
          "metric": "Métrica",
          "value": "Valor",
          "count": "Cantidad"
        }
      },
      "roadmap": {
        "releases": "Lanzamientos",
        "released": "Lanzado",
        "lastVersion": {
          "active": {
            "false": "Elemento eliminado de la hoja de ruta",
            "true": "Elemento re-agregado a la hoja de ruta"
          },
          "released": "Item was released to PU",
          "release": "Item moved from release %{old} to %{new}"
        },
        "stories": {
          "one": "%{count} Story",
          "other": "%{count} Stories"
        },
        "tasks": {
          "one": "of %{count} Task",
          "other": "of %{count} Tasks"
        },
        "ships": {
          "one": "%{count} Ship",
          "other": "%{count} Ships"
        }
      },
      "unknown": "Desconocido",
      "none": "-",
      "notAvailable": "N/A",
      "not-available": "N/A",
      "name": "Nombre",
      "homepage": "Página principal",
      "discord": "Servidor de Discord",
      "youtube": "Canal de Youtube",
      "twitch": "Canal de Twitch",
      "guilded": "Servidor de Guilded",
      "3dView": "3D",
      "3dMap": "Map",
      "texturedHolo": "Texturizado",
      "viewInAr": "RA",
      "viewInArHint": "Colócala en tu habitación a tamaño real",
      "filter": "Filtro",
      "taxExcluded": "sin IVA",
      "hangar": "Hangar",
      "public": "Público",
      "hangarStats": "Estadísticas",
      "wishlist": "Lista de deseos",
      "fleetchart": "Gráfico de flota",
      "fleetchartScale": "Escala de naves",
      "fleetchartApp": {
        "screenHeight": "Altura de pantalla",
        "viewpoint": "Punto de vista",
        "screenHeightOptions": {
          "auto": "Auto",
          "1x": "1x",
          "1_5x": "1.5x",
          "2x": "2x",
          "3x": "3x",
          "4x": "4x"
        },
        "viewpointOptions": {
          "port": "Babor",
          "top": "Superior",
          "angled": "Angular",
          "front": "Frontal"
        },
        "gridSize": "%{size} metro por cuadrícula",
        "mode": "Modo",
        "modeOptions": {
          "classic": "Clásico",
          "panzoom": "v2"
        }
      },
      "fleetStats": "Estadísticas",
      "hangarMetrics": {
        "total": "Total",
        "totalMoney": "Money Value",
        "totalCredits": "Credits",
        "totalIngameValue": "Valor aUEC del hangar",
        "totalCrew": "Tripulación",
        "totalCargo": "Carga total",
        "largestShip": "Nave más grande",
        "smallestShip": "Nave más pequeña",
        "averagePledgePrice": "Precio promedio de Pledge",
        "flightReady": "Listo para volar",
        "uniqueModels": "Modelos únicos",
        "manufacturerCount": "Fabricantes",
        "missingClassifications": "Roles faltantes",
        "wishlistTotalMoney": "Valor de Pledge de lista de deseos",
        "wishlistTotalCredits": "Valor en juego de lista de deseos"
      },
      "selectModel": "Seleccionar una nave",
      "findModel": "Escribe para buscar una nave",
      "find": "Escribe para buscar",
      "selectUser": "Seleccionar un usuario",
      "findUser": "Escriba para buscar un usuario",
      "selectAdminUser": "Seleccionar un usuario administrador",
      "selectFleet": "Seleccionar una flota",
      "findFleet": "Escriba para buscar una flota",
      "compare": {
        "removeModel": "Eliminar nave",
        "addModel": {
          "nullablePrompt": "Agregar una nave"
        },
        "enough": "Don't you think 8 Ships are enough? ;)",
        "shipCount": {
          "one": "%{count} nave",
          "other": "%{count} naves"
        },
        "containersOfSize": "Contenedores de %{size} SCU",
        "armorHp": "HP de blindaje",
        "fuelAndQuantum": "Combustible y Quantum",
        "weaponPoolSize": "Reserva de energía de armas",
        "crossSection": {
          "x": "Sección transversal X",
          "y": "Sección transversal Y",
          "z": "Sección transversal Z"
        },
        "useAsBaseline": "Usar como referencia",
        "baseline": "Referencia",
        "differencesOnly": "Solo diferencias",
        "compareToBaseline": "Comparar con la referencia",
        "loadoutBySlot": "Configuración por slot",
        "slots": {
          "guns": "Cañones principales",
          "turrets": "Torretas",
          "missiles": "Misiles",
          "shields": "Generadores de escudo",
          "powerPlants": "Plantas de energía",
          "coolers": "Enfriadores",
          "quantumDrives": "Motores Quantum",
          "thrusters": "Propulsores principales",
          "countermeasures": "Contramedidas"
        },
        "legend": {
          "best": "mejor de la fila",
          "worst": "peor",
          "share": "porcentaje del mejor de la fila",
          "better": "supera la referencia",
          "worse": "por detrás de ella"
        },
        "selectShips": "Seleccionar naves"
      },
      "au": "AU",
      "uec": "aUEC",
      "sell": "Vender",
      "buy": "Comprar",
      "yourFlagship": "Su nave insignia",
      "flagship": "Nave insignia",
      "fleet": {
        "headquarters": "Cuartel general",
        "index": "Flota",
        "destroyInfo": "If you want to delete this Fleet and remove all its information from Fleetyards.net click the button below. Be aware that this is a permanent action and can't be reverted.",
        "classes": "Flota",
        "fid": "ID de flota",
        "name": "Nombre",
        "logo": "Logo",
        "rsiSid": "SID",
        "rsiSettings": {
          "hint": "El ID de flota es la dirección de tu flota en Fleetyards. El SID vincula la flota con su organización de RSI, y verificarlo demuestra que la organización es tuya."
        },
        "fidClaim": {
          "claimableTitle": "Reclamar el ID de flota %{fid}",
          "claimable": "Tu flota está verificada para la organización de RSI %{fid}, pero otra flota tiene el ID de flota %{fid}. Si lo reclamas, esa flota tiene 14 días para demostrar ella misma la organización o avisar a sus miembros. Después se le cambia el nombre y %{fid} pasa a ser el ID de tu flota.",
          "pendingTitle": "Reclamación de %{fid} en curso",
          "pending": "%{holder} conserva %{fid} hasta el %{date}. Después el ID pasa a tu flota, salvo que esa flota demuestre antes que gestiona la organización %{fid}.",
          "availableTitle": "El ID de flota %{fid} está libre",
          "available": "Tu flota está verificada para %{fid} y ninguna otra flota usa ese ID. Ponlo arriba como ID de tu flota.",
          "incomingTitle": "%{claimant} reclama el ID de tu flota",
          "incoming": "%{claimant} está verificada para la organización de RSI **%{fid}**.\n\n**El %{date}:**\n\n- Tu flota pasa al siguiente ID de flota libre, como **%{fid}-1**.\n- Los enlaces a %{fid} abrirán %{claimant} desde entonces.\n\n**Para conservar el ID**, verifica %{fid} antes. Si no, avisa a tus miembros de la nueva dirección.",
          "createTakenTitle": "%{fid} ya está en uso",
          "createTaken": "Si %{fid} es tu organización de RSI, empieza con %{suggestion} y el SID %{fid}. En cuanto tu flota esté verificada para %{fid}, podrá reclamar el ID de flota a la flota que lo tiene."
        },
        "rsiVerification": {
          "extension": {
            "title": "Verificar con la extensión FleetYards Sync",
            "verify": "Verificar con la extensión",
            "description": "La extensión añade tu código a la historia de tu organización en RSI, la publica, comprueba la página y vuelve a quitar el código.",
            "detecting": "Buscando la extensión FleetYards Sync",
            "install": "Instala la extensión FleetYards Sync para verificar tu flota con un clic.",
            "update": "Actualiza la extensión FleetYards Sync para verificar tu flota con un clic: la versión instalada aún no lo admite.",
            "notSignedIn": "Inicia sesión en RSI en este navegador con una cuenta que pueda editar %{sid}, o verifica a mano más abajo.",
            "noRights": "La cuenta de RSI con la que este navegador ha iniciado sesión no puede editar la página de %{sid}. Inicia sesión con una cuenta de oficial o verifica a mano más abajo.",
            "pendingChanges": "%{sid} tiene cambios sin publicar en RSI. Publica o borra ese borrador primero, para que la extensión no publique la edición de otra persona, o verifica a mano más abajo.",
            "orgUnreadable": "La extensión no pudo leer la página de %{sid} en RSI. Verifica a mano más abajo.",
            "failed": "La extensión no pudo actualizar la página de %{sid}. Inténtalo de nuevo o verifica a mano más abajo.",
            "removeFailed": "La extensión no pudo quitar el código de la historia de %{sid}. Quítalo allí a mano.",
            "manual": "O verifica a mano:"
          },
          "steps": {
            "copy": "Copia tu código de verificación",
            "paste": "Pégalo en cualquier parte de la página pública de RSI de tu organización: la introducción, la historia, el manifiesto o la carta. Puedes quitarlo cuando la flota esté verificada.",
            "check": "Comprueba la página"
          },
          "openOrgPage": "Abrir %{sid} en RSI",
          "fidAtRiskTitle": "El ID de tu flota no está protegido",
          "saveFirst": "Guarda el SID antes de verificarlo.",
          "title": "Verificación de RSI",
          "token": "Código de verificación",
          "verified": "Organización de RSI verificada",
          "unverified": "No verificada en RSI",
          "verifiedSince": "Verificada desde %{date}",
          "nextCheck": "Puedes volver a comprobar en un minuto.",
          "fidAtRisk": "Otra flota que verifique la organización de RSI %{fid} puede reclamarlo, y la dirección de tu flota cambia.",
          "statuses": {
            "pending": "Comprobando la página de la organización…",
            "token_missing": "El código aún no está en la página de la organización. RSI puede tardar unos minutos en mostrar un cambio.",
            "symbol_mismatch": "La página que devolvió RSI pertenece a otra organización.",
            "not_found": "RSI no tiene ninguna organización con este SID.",
            "failed": "No se pudo comprobar la página de la organización. Inténtalo de nuevo en un minuto."
          }
        },
        "description": "Descripción",
        "public": "Vista de flota pública",
        "publicFleet": "Flota pública",
        "publicStats": "Estadísticas públicas",
        "publicFleetStats": "Estadísticas de flota públicas",
        "discord": {
          "url": "Servidor de Discord",
          "hint": "Conecta un servidor de Discord para reflejar los eventos como eventos programados nativos. Los miembros pueden confirmar su asistencia desde Discord y la inscripción se sincronizará de vuelta con Fleetyards.",
          "guildId": "ID del servidor de Discord",
          "channelId": "ID del canal de voz (opcional)",
          "webhookUrl": "URL del webhook de anuncios (opcional)",
          "installBotHint": "Abre la página de instalación de Discord en una pestaña nueva — elige el servidor al que quieres reflejar los eventos.",
          "announcementChannel": "Canal de anuncios",
          "announcementChannelHint": "Aquí se publican los eventos nuevos y los recordatorios de inicio. Sin canal, se envían por el webhook. Los eventos restringidos a escuadrones se publican en los canales de esos escuadrones.",
          "officersChannel": "Canal de oficiales",
          "officersChannelHint": "Los eventos visibles solo para oficiales se anuncian aquí y en ningún otro sitio de Discord. Sin canal, no se anuncian en Discord. Las solicitudes de ingreso también se publican aquí, con botones para aceptarlas o rechazarlas.",
          "digestWeekday": "Resumen semanal",
          "digestWeekdayHint": "Una vez por semana, cada canal recibe una lista de los eventos de los próximos siete días que puede ver. Déjalo vacío para desactivarlo.",
          "digestTime": "Hora del resumen",
          "digestTimeHint": "En tu zona horaria (%{timezone}).",
          "channelMissing": "Este canal ya no existe en Discord o ya no admite publicaciones. No se publica nada hasta elegir otro.",
          "missingChannel": "Canal no disponible",
          "joinRole": "Rol de ingreso",
          "joinRoleHint": "Los jugadores con este rol en el servidor se unen a la flota sin solicitud, con el rango predeterminado. Si se les quita el rol, los miembros que entraron con él salen de la flota. Déjalo vacío para aprobar cada solicitud a mano.",
          "roleMissing": "Este rol ya no existe en Discord. Nadie se une con él hasta que se elija otro.",
          "missingRole": "Rol no disponible",
          "saveGuildFirst": "Guarda primero el nuevo servidor y luego elige sus canales y roles.",
          "roleMapping": "Roles de Discord",
          "roleMappingHint": "Fleetyards da estos roles a los miembros en el servidor y se los quita cuando cambian de rango o dejan la flota. Solo añade o quita los roles elegidos aquí.",
          "memberRole": "Rol de miembro",
          "memberRoleHint": "Todos los miembros de la flota reciben este rol, sea cual sea su rango.",
          "rolesCodes": {
            "missing_manage_roles": "El bot no puede gestionar roles en este servidor. Usa el enlace de instalación para volver a autorizarlo.",
            "unknown_role": "Un rol elegido aquí ya no existe en Discord: %{names}.",
            "role_above_bot": "El bot no puede asignar %{names}: Discord solo le deja dar roles por debajo del suyo. Sube el rol del bot por encima de ellos en los ajustes del servidor."
          },
          "postingCodes": {
            "missing_send_messages": "El bot no puede enviar mensajes en este servidor. Usa el enlace de instalación para volver a autorizarlo.",
            "channel_locked": "El bot no puede publicar en el canal elegido para %{names}. Permítelo en los permisos de ese canal.",
            "unknown_channel": "El canal elegido para %{names} ya no existe en Discord o ya no admite publicaciones.",
            "channel_shared": "%{names} comparte un canal con lectores a los que no se muestran sus eventos. No se publica nada allí hasta que cada uno tenga un canal propio."
          },
          "joinRoleCodes": {
            "members_intent_missing": "El bot de Fleetyards aún no puede listar los miembros de este servidor, así que el rol de ingreso solo se aplica cuando un jugador usa un enlace de invitación. Contacta con un administrador.",
            "live_updates_off": "Los cambios de rol llegan a Fleetyards una vez al día: el bot no los escucha en el momento. Contacta con un administrador.",
            "bot_offline": "El bot de Fleetyards no está conectado a Discord ahora mismo, así que los cambios de rol esperan a la sincronización diaria. Contacta con un administrador."
          },
          "statusOk": "Conectado a %{name}",
          "statusCodes": {
            "missing_token": "El bot de Fleetyards no está configurado en el lado del servidor. Contacta con un administrador.",
            "missing_guild": "Introduce primero un ID de servidor de Discord.",
            "invalid_token": "El token del bot no es válido. Contacta con un administrador.",
            "bot_not_in_guild": "El bot no está en este servidor. Usa el enlace de instalación para añadirlo.",
            "guild_not_found": "Discord no reconoce este ID de servidor. Revisa el valor.",
            "discord_error": "Discord devolvió un error inesperado.",
            "request_failed": "No se pudo contactar con Fleetyards. Inténtalo de nuevo."
          }
        },
        "guilded": "Servidor de Guilded",
        "homepage": "Página principal",
        "twitch": "Canal de Twitch",
        "youtube": "Canal de Youtube",
        "backgroundImage": "Imagen de fondo",
        "ts": "Servidor Teamspeak",
        "awaitingConfirmation": "Esperando confirmación de la flota",
        "members": {
          "verifiedOrgMember": "Miembro verificado de %{sid}",
          "verifiedOrgMemberChecked": "Miembro verificado de %{sid}, comprobado %{checked}",
          "primary": "¿Flota principal?",
          "shipsFilter": {
            "label": "¿Qué naves deben agregarse a la flota?",
            "nullablePrompt": "No se seleccionó ninguna opción",
            "field": "Selección de naves",
            "values": {
              "all": "Todas las naves",
              "hangar_group": "Todas las naves en un grupo de hangar dado",
              "hide": "Sin naves"
            }
          },
          "hangarGroupId": {
            "field": "Grupo de hangar",
            "label": "Especifique un grupo de hangar",
            "nullablePrompt": "No se seleccionó ningún grupo"
          },
          "blueprintsFilter": {
            "label": "¿Qué planos deben compartirse con la flota?",
            "nullablePrompt": "Ninguna opción seleccionada",
            "field": "Selección de planos",
            "values": {
              "all": "Todos los planos que poseo",
              "hide": "Ningún plano"
            }
          },
          "total": "Total: %{count}",
          "rsiTotal": "En RSI: %{count}",
          "joined": "Unido el",
          "invited": "Invitado",
          "invitedAt": "Invitado / Solicitado el",
          "requested": "Membresía solicitada",
          "declined": "Rechazado",
          "pending": "Invitaciones y solicitudes pendientes",
          "accepted": "Miembros",
          "role": "Rol",
          "contact": "Contact",
          "spectrumDm": "Message on Spectrum",
          "discordContact": "Discord",
          "views": {
            "members": "Miembros",
            "invites": "Invitaciones"
          },
          "health": {
            "overview": "Comprobaciones",
            "summary": {
              "attention": {
                "one": "%{count} de %{total} comprobaciones requiere atención",
                "other": "%{count} de %{total} comprobaciones requieren atención"
              },
              "clear": "Las %{total} comprobaciones están en orden"
            },
            "groups": {
              "leadership": "Liderazgo",
              "rsi": "Organización de RSI",
              "activity": "Actividad",
              "requests": "Solicitudes e invitaciones",
              "integrations": "Integraciones"
            },
            "days": {
              "one": "%{count} día",
              "other": "%{count} días"
            },
            "checks": {
              "admins": {
                "title": "Administradores",
                "overview": "Administradores",
                "clear": "%{admins} miembros son administradores."
              },
              "unverified": {
                "title": "No verificados con %{sid}",
                "overview": "No verificados",
                "description": "Un miembro está verificado cuando su propia lista de organizaciones de RSI incluye %{sid}. Cada fila indica por qué no se pudo confirmar.",
                "clear": "Todos los miembros están verificados con %{sid}."
              },
              "noHandle": {
                "title": "Sin handle de RSI",
                "overview": "Sin handle de RSI",
                "clear": "Todos los miembros han indicado un handle de RSI."
              },
              "inactive": {
                "title": "Miembros inactivos",
                "overview": "Inactivos %{count}+ días",
                "clear": "Todos han estado activos en los últimos %{count} días."
              },
              "joinRequests": {
                "title": "Solicitudes de ingreso con más de una semana",
                "overview": "Solicitudes antiguas",
                "clear": "Ninguna solicitud ha esperado más de una semana."
              },
              "invitations": {
                "title": "Invitaciones sin respuesta",
                "overview": "Invitaciones sin respuesta",
                "clear": "Ninguna invitación lleva abierta más de dos semanas."
              },
              "inviteUrls": {
                "title": "Enlaces de invitación por revisar",
                "overview": "Enlaces de invitación",
                "clear": "Todos los enlaces de invitación están en uso."
              },
              "discord": {
                "title": "Sin Discord vinculado",
                "overview": "Discord",
                "clear": "Todos los miembros tienen Discord vinculado."
              },
              "emptySquadrons": {
                "title": "Escuadrones sin miembros",
                "overview": "Escuadrones vacíos",
                "clear": "Todos los escuadrones tienen miembros."
              },
              "noSquadron": {
                "title": "Miembros sin escuadrón",
                "overview": "Sin escuadrón",
                "clear": "Todos los miembros están en un escuadrón."
              },
              "hiddenShips": {
                "title": "Naves fuera de la flota",
                "overview": "Hangares ocultos",
                "clear": "Todos los miembros comparten sus naves con la flota."
              }
            },
            "facts": {
              "joined": "Se unió el %{date}",
              "lastActive": "Última actividad %{distance}",
              "neverActive": "Nunca activo",
              "checked": "Comprobado %{distance}",
              "requested": "Solicitado %{distance}",
              "invited": "Invitado %{distance}",
              "invitedBy": "Invitado por %{name}",
              "noDiscord": "Sin cuenta de Discord vinculada",
              "noSquadron": "Sin escuadrón",
              "noHandle": "Sin handle indicado",
              "linkExpired": "Caducó %{distance}",
              "linkUsedUp": "Sin usos restantes",
              "createdBy": "Creado por %{name}",
              "used": {
                "one": "Usado una vez",
                "other": "Usado %{count} veces"
              },
              "team": "Equipo",
              "created": "Creado el %{date}",
              "linkUnused": "Nunca usado, creado %{distance}"
            },
            "gaps": {
              "no_handle": "Sin handle de RSI en el perfil",
              "handle_unverified": "Handle de RSI sin verificar",
              "orgs_not_checked": "Lista de organizaciones aún no leída",
              "org_not_listed": "%{sid} no está en su lista de organizaciones"
            },
            "orgStats": {
              "rsi": "%{sid} en RSI",
              "roster": "En FleetYards",
              "gap": "Nunca se unieron aquí"
            },
            "fleetNotVerified": "%{sid} aún no está verificada, por lo que en ningún otro lugar se muestra a ningún miembro como verificado.",
            "singleAdmin": "Si %{name} se va o pierde el acceso, nadie podrá gestionar %{fleet} en FleetYards.",
            "hiddenShips": {
              "one": "%{count} miembro mantiene su hangar fuera de la lista de naves de la flota.",
              "other": "%{count} miembros mantienen su hangar fuera de la lista de naves de la flota."
            },
            "deleteLinkFailed": "No se pudo eliminar el enlace de invitación.",
            "noAdmin": "Nadie es administrador, así que nadie puede gestionar %{fleet} en FleetYards.",
            "adminCandidates": "Ascender a administrador",
            "addedToSquadron": {
              "success": "Añadido al escuadrón.",
              "failure": "No se pudo añadir al escuadrón."
            },
            "reminded": {
              "success": "Recordatorio enviado.",
              "failure": "No se pudo enviar el recordatorio."
            },
            "remindedAt": "Recordado %{distance}. Puedes volver a recordar una semana después."
          },
          "card": {
            "verified": "Verificado",
            "unverified": "No verificado",
            "squadrons": "Escuadrones"
          }
        },
        "squadrons": {
          "index": "Escuadrones",
          "name": "Nombre",
          "shortDescription": "Descripción breve",
          "shortDescriptionHint": "Una o dos líneas, en la tarjeta",
          "description": "Descripción",
          "descriptionHint": "El texto completo en la página del escuadrón",
          "noDescription": "Todavía no se ha añadido una descripción.",
          "icon": "Icono",
          "iconHint": "Imagen cuadrada, se muestra en un círculo",
          "team": "Equipo",
          "teamHint": "Un equipo está abierto a todos; de lo contrario, un miembro pertenece a un solo escuadrón",
          "restrictedToHint": "Solo estos escuadrones pueden verlo",
          "discordChannel": "Canal de Discord",
          "discordChannelHint": "Los eventos restringidos a este escuadrón se anuncian aquí y en ningún otro sitio de Discord. Sin canal, no se anuncian en Discord.",
          "notAnnounced": "No se anuncia en Discord para %{names}: no hay un canal de Discord configurado.",
          "blockedBy": "Ya está en el escuadrón %{squadron}",
          "color": "Color",
          "colorSuggestions": "Del icono:",
          "memberCount": "%{count} miembros",
          "members": "Miembros",
          "joinedAt": "Fecha de ingreso al escuadrón",
          "searchMembers": "Buscar miembros",
          "availableMembers": "miembros disponibles",
          "selectedMembers": "%{count} seleccionados",
          "rank": "Rango",
          "ranksHint": "Los nombres que usa cada escuadrón de esta flota. Un rango renombrado conserva su lugar y sus permisos.",
          "rankName": "Nombre",
          "defaultRank": "Predeterminado",
          "defaultRankToggle": "Los miembros nuevos empiezan con este rango",
          "rankRights": {
            "singleHolder": "Uno por escuadrón",
            "managesMembers": "Añade y quita a los miembros de rango inferior",
            "managesRanks": "Asigna los rangos por debajo del suyo"
          },
          "views": {
            "members": "Miembros",
            "requests": "Solicitudes"
          },
          "requestedAt": "Solicitado el",
          "requests": "Solicitudes"
        },
        "roles": {
          "permanent": "Permanente",
          "default": "Predeterminado",
          "defaultToggle": "Los miembros nuevos reciben este rol",
          "privilegeGroups": {
            "fleet": "Flota",
            "memberships": "Miembros",
            "squadrons": "Escuadrones",
            "invites": "Invitaciones",
            "vehicles": "Vehículos",
            "blueprints": "Planos",
            "roles": "Roles",
            "inventories": "Inventarios",
            "missions": "Misiones",
            "events": "Eventos",
            "allies": "Aliados",
            "contracts": "Contratos",
            "payouts": "Pagos",
            "notifications": "Notificaciones",
            "announcements": "Anuncios"
          },
          "privileges": {
            "fleet:update": "Actualizar flota",
            "fleet:update:images": "Actualizar imágenes",
            "fleet:update:description": "Actualizar descripción",
            "fleet:delete": "Eliminar flota",
            "fleet:manage": "Administrar flota",
            "fleet:memberships:read": "Ver miembros",
            "fleet:memberships:create": "Invitar miembros",
            "fleet:memberships:update": "Actualizar miembros",
            "fleet:memberships:delete": "Eliminar miembros",
            "fleet:memberships:manage": "Administrar miembros",
            "fleet:squadrons:read": "Ver escuadrones",
            "fleet:squadrons:create": "Crear escuadrones",
            "fleet:squadrons:update": "Editar escuadrones",
            "fleet:squadrons:delete": "Eliminar escuadrones",
            "fleet:squadrons:members:manage": "Gestionar miembros del escuadrón",
            "fleet:squadrons:manage": "Gestionar escuadrones",
            "fleet:invites:read": "Ver invitaciones",
            "fleet:invites:create": "Crear invitaciones",
            "fleet:invites:update": "Actualizar invitaciones",
            "fleet:invites:delete": "Eliminar invitaciones",
            "fleet:invites:manage": "Administrar invitaciones",
            "fleet:vehicles:read": "Ver vehículos",
            "fleet:vehicles:create": "Agregar vehículos",
            "fleet:vehicles:update": "Actualizar vehículos",
            "fleet:vehicles:delete": "Eliminar vehículos",
            "fleet:vehicles:manage": "Administrar vehículos",
            "fleet:blueprints:read": "Ver planos",
            "fleet:roles:read": "Ver roles",
            "fleet:roles:create": "Crear roles",
            "fleet:roles:update": "Actualizar roles",
            "fleet:roles:delete": "Eliminar roles",
            "fleet:roles:manage": "Administrar roles",
            "fleet:inventories:read": "Ver inventarios",
            "fleet:inventories:create": "Crear inventarios",
            "fleet:inventories:update": "Actualizar inventarios",
            "fleet:inventories:delete": "Eliminar inventarios",
            "fleet:inventories:manage": "Gestionar inventarios",
            "fleet:missions:read": "Ver misiones",
            "fleet:missions:create": "Crear misiones",
            "fleet:missions:update": "Actualizar misiones",
            "fleet:missions:delete": "Eliminar misiones",
            "fleet:missions:manage": "Gestionar misiones",
            "fleet:events:read": "Ver eventos",
            "fleet:events:create": "Crear eventos",
            "fleet:events:update": "Actualizar eventos",
            "fleet:events:delete": "Eliminar eventos",
            "fleet:events:manage": "Gestionar eventos",
            "fleet:allies:read": "Ver aliados",
            "fleet:allies:create": "Añadir aliados",
            "fleet:allies:delete": "Quitar aliados",
            "fleet:allies:manage": "Gestionar aliados",
            "fleet:contracts:read": "Ver contratos",
            "fleet:contracts:create": "Crear contratos",
            "fleet:contracts:update": "Actualizar contratos",
            "fleet:contracts:delete": "Eliminar contratos",
            "fleet:contracts:manage": "Gestionar contratos",
            "fleet:payouts:read": "Ver pagos",
            "fleet:payouts:create": "Registrar pagos",
            "fleet:payouts:update": "Actualizar pagos",
            "fleet:payouts:delete": "Eliminar pagos",
            "fleet:payouts:manage": "Gestionar pagos",
            "fleet:notifications:manage": "Gestionar la configuración de notificaciones",
            "fleet:announcements:manage": "Gestionar anuncios"
          },
          "name": "Nombre",
          "rank": "Rango"
        },
        "inviteUrls": {
          "noExpiration": "Never expires",
          "used": "Usado %{count} veces",
          "usedOfLimit": "%{count} de %{limit} usados",
          "expiresIn": "Expires in %{time}",
          "expired": "Expired",
          "expiresAfterOptions": {
            "infinite": "Never",
            "30_minutes": "30 minutes",
            "1_hour": "1 hour",
            "6_hours": "6 hours",
            "12_hours": "12 hours",
            "1_day": "1 día",
            "7_days": "7 days"
          },
          "limitOptions": {
            "1": "1 use",
            "5": "5 uses",
            "10": "10 uses",
            "25": "25 uses",
            "50": "50 uses",
            "100": "100 uses",
            "infinite": "No limit"
          }
        },
        "calendarSubscription": {
          "intro": "Genera un enlace privado que los miembros pueden usar para suscribirse a los eventos de esta flota desde su aplicación de calendario (Apple Calendar, Google Calendar, Outlook).",
          "howTo": "Comparte el enlace de arriba con tus miembros. Ellos lo pegan en su aplicación de calendario (\"Suscribirse al calendario\" o \"Añadir por URL\"). El enlace es privado: cualquiera que lo tenga puede ver los eventos de esta flota."
        },
        "notifications": {
          "inAppHint": "Elige qué cambios del ciclo de vida de los eventos aparecen como notificaciones en la app para los miembros de la flota.",
          "events": {
            "fleet_event": {
              "published": "Evento publicado",
              "locked": "Inscripciones bloqueadas",
              "unlocked": "Inscripciones reabiertas",
              "starting_soon": "El evento empieza pronto",
              "started": "Evento iniciado",
              "completed": "Evento completado",
              "cancelled": "Evento cancelado",
              "archived": "Evento archivado",
              "destroyed": "Evento eliminado"
            },
            "fleet_event_signup": {
              "created": "Inscripción añadida",
              "withdrawn": "Inscripción retirada"
            }
          }
        },
        "inventories": {
          "name": "Nombre",
          "description": "Descripción",
          "location": "Ubicación",
          "visibility": "Visibilidad",
          "manager": "Gestor",
          "itemsCount": "Entradas",
          "visibilities": {
            "members_only": "Solo miembros",
            "officers_only": "Solo oficiales",
            "squadron_only": "Solo escuadrón"
          }
        },
        "allies": "Naves visibles para los aliados",
        "alliesStats": "Estadísticas visibles para los aliados",
        "alliesMembers": "Lista de miembros visible para los aliados",
        "squadronsEnabled": "Usar escuadrones",
        "listed": "Mostrar en el directorio de flotas",
        "listedInfo": "Una flota verificada y pública con al menos dos miembros aparece en el directorio de flotas. Una flota privada nunca aparece.",
        "alignment": "Alineamiento",
        "alignments": {
          "lawful": "Legal",
          "neutral": "Neutral",
          "outlaw": "Forajido"
        },
        "activities": {
          "bounty_hunting": "Caza de recompensas",
          "engineering": "Ingeniería",
          "exploration": "Exploración",
          "freelancing": "Trabajo autónomo",
          "infiltration": "Infiltración",
          "medical": "Medicina",
          "piracy": "Piratería",
          "resources": "Recursos",
          "scouting": "Reconocimiento",
          "security": "Seguridad",
          "smuggling": "Contrabando",
          "social": "Social",
          "trading": "Comercio",
          "transport": "Transporte"
        },
        "commitments": {
          "casual": "Casual",
          "regular": "Regular",
          "hardcore": "Hardcore"
        },
        "rsiProfile": {
          "info": "Se sincroniza una vez al día desde la página de RSI de tu organización. Cámbialo en RSI.",
          "primaryActivity": "Actividad principal",
          "secondaryActivity": "Actividad secundaria",
          "language": "Idioma",
          "commitment": "Compromiso",
          "recruiting": "Reclutando",
          "roleplay": "Rol"
        },
        "contractCovers": {
          "transport": "Portada de transporte",
          "procurement": "Portada de adquisición",
          "crafting": "Portada de fabricación"
        }
      },
      "hangarGroup": {
        "name": "Nombre",
        "color": "Color",
        "sort": "Orden",
        "public": "¿Mostrar en hangar público?"
      },
      "source": "Fuente",
      "loadout": {
        "marker": "Equipamiento «%{name}»",
        "fleetyards": "Configuración de Fleetyards",
        "namePlaceholder": "Nombre de la configuración...",
        "urlPlaceholder": "Pega la URL de una configuración de erkul.games o spviewer.eu...",
        "empty": "Aún no hay configuraciones. Crea una para empezar.",
        "active": "Activa",
        "activate": "Marcar como activa"
      },
      "model": {
        "hidden": "¿Oculto?",
        "active": "¿Activo?",
        "inGame": "¿En el juego?",
        "adiMap": "¿Mapa ADI?",
        "ground": "¿Vehículo terrestre?",
        "productionNote": "Nota de producción",
        "rsiId": "RSI ID",
        "length": "Longitud",
        "beam": "Manga",
        "height": "Altura",
        "scKey": "SC Key",
        "price": "Precio",
        "pledgePrice": "Precio de Pledge",
        "erkulIdentifier": "Erkul Identifier",
        "mass": "Masa",
        "crew": "Tripulación",
        "storeUrl": "Store URL",
        "salesPageUrl": "Sales Page URL",
        "scmSpeed": "SCM Speed",
        "scmSpeedBoosted": "SCM Speed Boosted",
        "maxSpeed": "Velocidad máx.",
        "reverseSpeedBoosted": "Reverse Speed Boosted",
        "cargo": "Carga",
        "cargoHolds": "Bodegas de carga",
        "keepCargo": "Mantener esta cifra de carga en lugar de las bodegas de los archivos del juego",
        "hydrogenFuelTankSize": "Tamaño del tanque de hidrógeno",
        "hydrogenFuelTanks": "Tanques de combustible de hidrógeno",
        "quantumFuelTankSize": "Tamaño del tanque Quantum",
        "quantumFuelTanks": "Tanques de combustible Quantum",
        "externalFuelTanks": "Tanques de combustible externos",
        "orePods": "Contenedores de mineral",
        "weaponRacks": "Armeros",
        "medicalBedsTier": "Camas médicas de nivel %{tier}",
        "medicalBedsNamed": "Camas médicas (%{name})",
        "respawnBeds": "Camas de reaparición",
        "salvageStorage": "Almacén de chatarra",
        "externalFuelTanksTotal": "Capacidad total",
        "externalFuelTanksCount": "Pods",
        "refuelBoom": "Brazo de repostaje",
        "refuelBoomArm": "Brazo",
        "refuelBoomNozzle": "Boquilla",
        "yaw": "Yaw",
        "pitch": "Pitch",
        "roll": "Roll",
        "yawBoosted": "Guiñada potenciada",
        "pitchBoosted": "Cabeceo potenciado",
        "rollBoosted": "Balanceo potenciado",
        "variants": "Variantes",
        "manufacturer": "Fabricante",
        "loaners": "Prestados",
        "paints": "Pinturas",
        "modules": "Módulos",
        "modulePackages": "Paquetes de módulos",
        "upgrades": "Kits de mejora",
        "brochure": "Folleto",
        "holo": "Holo",
        "angledView": "Vista angular",
        "angledViewColored": "Vista angular a color",
        "portView": "Vista de babor",
        "portViewColored": "Vista de babor a color",
        "frontView": "Vista frontal",
        "frontViewColored": "Vista frontal a color",
        "topView": "Vista superior",
        "topViewColored": "Vista superior a color",
        "onSale": "En venta",
        "playerOwnable": "¿Adquirible por jugadores?",
        "ingameOnly": "Solo en el juego",
        "canLandOnPlanets": "Puede aterrizar en planetas",
        "cannotLandOnPlanets": "No puede aterrizar en planetas",
        "salesPage": "Página de venta",
        "addons": "Módulos y kits de mejora",
        "storeImage": "Imagen de tienda",
        "wiki": "Star Citizen Wiki",
        "crewPositions": "Posiciones de tripulación",
        "needsCuration": "Necesita curación",
        "curatedPosition": "Posición curada manualmente",
        "baseModel": "Modelo base",
        "fleetchartOffsetLength": "Desfase de longitud del gráfico de flota",
        "fleetchartOffsetBeam": "Desfase de manga del gráfico de flota",
        "extendedLength": "Longitud extendida",
        "extendedBeam": "Manga extendida",
        "extendedHeight": "Altura extendida",
        "extendedFleetchartOffsetLength": "Desplazamiento de longitud extendida del diagrama de flota",
        "extendedFleetchartOffsetBeam": "Desplazamiento de manga extendida del diagrama de flota",
        "defaultHolo": "Holo por defecto",
        "extendedHolo": "Holo extendido",
        "extendedTopView": "Vista superior extendida",
        "extendedTopViewColored": "Vista superior extendida en color",
        "extendedPortView": "Vista de babor extendida",
        "extendedPortViewColored": "Vista de babor extendida en color",
        "extendedFrontView": "Vista frontal extendida",
        "extendedFrontViewColored": "Vista frontal extendida en color",
        "extendedAngledView": "Vista en ángulo extendida",
        "extendedAngledViewColored": "Vista en ángulo extendida en color",
        "landedHolo": "Holo aterrizado",
        "landedTopView": "Vista superior aterrizada",
        "landedPortView": "Vista de babor aterrizada",
        "landedFrontView": "Vista frontal aterrizada",
        "landedAngledView": "Vista en ángulo aterrizada",
        "landedTopViewColored": "Vista superior aterrizada en color",
        "landedPortViewColored": "Vista de babor aterrizada en color",
        "landedFrontViewColored": "Vista frontal aterrizada en color",
        "landedAngledViewColored": "Vista en ángulo aterrizada en color",
        "angledRearView": "Vista angular trasera",
        "angledRearViewColored": "Vista angular trasera a color",
        "bottomView": "Vista inferior",
        "bottomViewColored": "Vista inferior a color",
        "rearView": "Vista trasera",
        "rearViewColored": "Vista trasera a color",
        "starboardView": "Vista de estribor",
        "starboardViewColored": "Vista de estribor a color",
        "extendedAngledRearView": "Vista angular trasera extendida",
        "extendedAngledRearViewColored": "Vista angular trasera extendida en color",
        "extendedBottomView": "Vista inferior extendida",
        "extendedBottomViewColored": "Vista inferior extendida en color",
        "extendedRearView": "Vista trasera extendida",
        "extendedRearViewColored": "Vista trasera extendida en color",
        "extendedStarboardView": "Vista de estribor extendida",
        "extendedStarboardViewColored": "Vista de estribor extendida en color",
        "landedAngledRearView": "Vista angular trasera aterrizada",
        "landedAngledRearViewColored": "Vista angular trasera aterrizada en color",
        "landedBottomView": "Vista inferior aterrizada",
        "landedBottomViewColored": "Vista inferior aterrizada en color",
        "landedRearView": "Vista trasera aterrizada",
        "landedRearViewColored": "Vista trasera aterrizada en color",
        "landedStarboardView": "Vista de estribor aterrizada",
        "landedStarboardViewColored": "Vista de estribor aterrizada en color",
        "holoLite": "Holo ligero",
        "extendedHoloLite": "Holo ligero extendido",
        "landedHoloLite": "Holo ligero aterrizado",
        "holoTextured": "Holo texturizado",
        "state": {
          "flight": "En vuelo",
          "extended": "Extendido",
          "landed": "Aterrizado"
        },
        "productionStatus": {
          "in-production": "En producción",
          "in-concept": "En concepto",
          "ready": "Listo para hangar",
          "flight-ready": "Listo para volar",
          "announced": "Anunciado"
        },
        "carriedBy": "Puede ser transportada por",
        "landedLength": "Longitud aterrizado",
        "landedBeam": "Manga aterrizado",
        "landedHeight": "Altura aterrizado",
        "landedFleetchartOffsetLength": "Desplazamiento de longitud aterrizado",
        "landedFleetchartOffsetBeam": "Desplazamiento de manga aterrizado",
        "owners": {
          "title": "En tu entorno",
          "yourShips": "Tus naves",
          "friends": "Amigos",
          "fleets": "Tus flotas",
          "more": "+%{count} más",
          "empty": "Nadie que conozcas tiene uno todavía.",
          "fleetShips": {
            "one": "%{count} nave",
            "other": "%{count} naves"
          }
        }
      },
      "models": {
        "extraColumns": "Columnas",
        "table": {
          "columns": {
            "storeImage": "Imagen",
            "storeImageWide": "Imagen ancha",
            "rsiStoreImage": "Imagen RSI",
            "rsiStoreImageWide": "Imagen RSI ancha",
            "angledView": "Imagen 3D",
            "angledViewWide": "Imagen 3D ancha",
            "rsiId": "RSI ID",
            "hidden": "Oculto",
            "active": "Activo",
            "createdAt": "Creado el",
            "updatedAt": "Actualizado el",
            "manufacturerName": "Fabricante",
            "length": "Longitud",
            "beam": "Manga",
            "height": "Altura",
            "mass": "Masa",
            "cargo": "Carga",
            "quantumFuelTankSize": "Combustible Quantum",
            "hydrogenFuelTankSize": "Combustible de hidrógeno",
            "crew": "Tripulación",
            "scmSpeed": "SCM Speed",
            "maxSpeed": "Velocidad máx.",
            "groundMaxSpeed": "Velocidad terrestre",
            "focus": "Enfoque",
            "productionStatus": "Estado de producción",
            "price": "Precio",
            "pledgePrice": "Precio de Pledge"
          }
        }
      },
      "metrics": {
        "info": "Info",
        "levels": "Niveles",
        "views": "Vistas",
        "base": "Base",
        "crew": "Tripulación",
        "speed": "Velocidad",
        "cargo": "Carga",
        "combat": "Combate",
        "hardpoints": "Puntos de montaje"
      },
      "flight": {
        "boostCapacitor": "Condensador de impulso",
        "boostCapacity": "Capacidad",
        "boostRegen": "Regeneración",
        "boostRegenDelay": "Retardo de regeneración",
        "boostRamp": "Arranque / parada",
        "title": "Vuelo",
        "scm": "crucero de combate",
        "nav": "crucero",
        "boost": "Boost",
        "boostSub": "postquemador",
        "reverse": "Marcha atrás",
        "maneuverability": "Maniobrabilidad",
        "fuel": "Combustible",
        "fuelHydrogen": "Hidrógeno",
        "fuelQuantum": "Quantum",
        "hint": "El manejo con boost escala con los pips del motor; todo queda a cero cuando el motor no tiene energía."
      },
      "base": {
        "price": "Precio",
        "priceInGame": "En el juego",
        "pricePledge": "Pledge",
        "availability": "Disponibilidad"
      },
      "availability": {
        "title": "Disponibilidad",
        "buy": "Comprar",
        "rent": "Alquilar",
        "sell": "Vender",
        "cheapest": {
          "buy": "Compra más barata",
          "rent": "Alquiler más barato"
        },
        "bestSale": "Mejor precio de venta",
        "allLocations": "Todas las ubicaciones",
        "locations": {
          "one": "%{count} ubicación",
          "other": "%{count} ubicaciones"
        },
        "empty": "No se conocen ubicaciones de compra ni de alquiler.",
        "timeRange": {
          "1-day": "1 día",
          "3-days": "3 días",
          "7-days": "7 días",
          "30-days": "30 días"
        }
      },
      "cargo": {
        "title": "Carga",
        "holdsSub": "en %{count} bodegas",
        "maxContainerSub": "la caja más grande que cabe",
        "containers": "Capacidad de contenedores",
        "hint": "Número máximo de contenedores de cada tamaño que caben en las grillas de carga; la barra muestra qué parte de la capacidad total ocupan."
      },
      "weaponRacks": {
        "slots": "Ranuras",
        "racks": "Armeros",
        "categories": {
          "weapon": "Arma",
          "gadget": "Dispositivo",
          "cargo": "Carga",
          "carriable": "Transportable",
          "armor": "Armadura",
          "other": "Otro"
        },
        "size": "S%{size}",
        "sizeRange": "S%{min}–S%{max}",
        "sizeUpTo": "hasta S%{size}",
        "only": "solo %{tag}",
        "tags": {
          "multitool": "Multiherramienta",
          "medical_injection": "Medpens",
          "grenade": "Granadas"
        },
        "hint": "Ranuras de todos los armeros a bordo, por lo que admiten y su tamaño."
      },
      "storageContainers": {
        "total": "Capacidad total",
        "count": "Contenedores",
        "perContainer": "cada uno",
        "hintOre": "Guarda mineral extraído, no carga.",
        "hintSalvage": "Guarda material recuperado, no carga."
      },
      "fuelTanks": {
        "capacitySub": "en %{count} pods",
        "podsSub": "montajes externos",
        "components": "Tipos de pod",
        "perPod": "por pod",
        "hint": "Combustible transportado en pods montados en puntos de montaje externos; la barra muestra la parte de la capacidad total que aporta cada tipo."
      },
      "refuelBoom": {
        "fuelFlowSub": "transferencia de hidrógeno",
        "quantumFlowSub": "transferencia de quantum",
        "captureRadiusSub": "tolerancia de acoplamiento",
        "equipment": "Equipamiento",
        "hint": "Tasas de transferencia del brazo de repostaje y tolerancia de acoplamiento de su boquilla."
      },
      "combat": {
        "title": "Combate",
        "openPenetrationCheck": "Comprobación de penetración",
        "dps": "DPS de ráfaga",
        "dpsSub": "%{count} armas",
        "sustained": "DPS sostenido",
        "sustainedSub": "con regeneración y calor",
        "alpha": "Alpha",
        "alphaSub": "por descarga",
        "weapons": "Armas",
        "missileDamage": "Daño de misiles",
        "armedMissiles": "Misiles armados",
        "armedMissilesSub": "%{cooldown} s entre lanzamientos",
        "composition": "Composición del daño",
        "damagePhysical": "Físico",
        "damageEnergy": "Energía",
        "damageDistortion": "Distorsión",
        "damageThermal": "Térmico",
        "controlComposition": "DPS por control",
        "controlGroups": {
          "pilot": "Piloto",
          "manned": "Torreta tripulada",
          "remote": "Torreta remota",
          "pds": "Defensa puntual"
        },
        "hint": "DPS de la configuración por defecto. El sostenido tiene en cuenta la regeneración de la reserva de energía de cada arma y su ciclo de sobrecalentamiento. Los misiles quedan excluidos."
      },
      "power": {
        "title": "Distribución de energía",
        "scm": "SCM",
        "nav": "NAV",
        "reset": "Restablecer",
        "auto": "Auto",
        "aimAssist": "Asistencia de puntería",
        "cooling": "Refrigeración",
        "ir": "IR",
        "em": "EM",
        "cs": "CS",
        "csAxisHint": "Haz clic para cambiar de eje (x / y / z)",
        "segmentsUsed": "%{used} / %{total} segmentos",
        "hint": "Reparte la energía entre los sistemas. El DPS sostenido de las armas escala con la energía que reciben; el resto se equilibra automáticamente.",
        "families": {
          "weapon": "Armas",
          "shield": "Escudos",
          "engine": "Motor",
          "radar": "Radar",
          "coolers": "Enfriadores",
          "qdrive": "Motor Quantum",
          "qed": "QED",
          "emp": "EMP",
          "lifeSupport": "Soporte vital",
          "miningLaser": "Láser de minería",
          "salvage": "Salvamento",
          "tractorBeam": "Rayo tractor",
          "towingbeam": "Rayo de remolque"
        }
      },
      "defense": {
        "title": "Defensa",
        "shieldHp": "HP de escudo",
        "shieldHpSub": "%{count} generadores",
        "shieldRegen": "Regeneración",
        "shieldResistances": "Resistencia",
        "shieldAbsorption": "Absorción",
        "shieldFaces": "Caras del escudo",
        "armor": "Blindaje",
        "deflection": "Deflexión",
        "armorReduction": "Reducción de daño",
        "armorSelfResistance": "Autorresistencia",
        "armorSignature": "Firma",
        "countermeasures": "Contramedidas",
        "countermeasureDuration": "Duración",
        "countermeasure": {
          "decoy": "Señuelo",
          "noise": "Ruido"
        },
        "damageType": {
          "physical": "Fís",
          "energy": "Energía",
          "distortion": "Distors",
          "thermal": "Térmico"
        },
        "signature": {
          "electromagnetic": "EM",
          "infrared": "IR",
          "crossSection": "CS"
        },
        "hint": "Valores de escudo, blindaje y contramedidas de la configuración por defecto. Una absorción inferior al 100 % significa que ese tipo de daño alcanza el casco incluso con los escudos activos.",
        "openDeflectionCheck": "Comprobación de deflexión"
      },
      "penetrationCheck": {
        "title": "Comprobación de penetración",
        "intro": "— ¿qué naves pueden perforar sus armas?",
        "noWeapons": "Esta configuración no monta cañones con daño por disparo que comprobar.",
        "weapons": "Armas",
        "shieldHealth": "Salud del escudo del objetivo",
        "armorHealth": "Salud del blindaje del objetivo",
        "ship": "Nave",
        "hoverHint": "Pasa el cursor sobre una nave para ver el desglose por arma.",
        "note": "Cada cañón seleccionado se compara con los escudos y la deflexión del blindaje de cada nave con las mismas reglas que la comprobación de deflexión; una nave queda perforada cuando cualquiera de ellos lo consigue, y se ordena por el cañón que más se acerca. Las naves sin blindaje se omiten, ya que no hay umbral que superar.",
        "sortBy": "Ordenar por",
        "sort": {
          "margin": "Margen",
          "ttk": "Tiempo hasta destruir"
        },
        "ttk": "TTK",
        "effectiveHp": "PV efectivos",
        "shieldsDown": "Escudos caídos",
        "ttkNote": "El tiempo hasta destruir usa el daño sostenido por segundo de los cañones seleccionados, con la distribución de energía actual, desde la salud de escudo y blindaje fijada arriba. Los escudos reciben el daño que absorben, menos su resistencia, y pasan el resto al blindaje, que lo recibe hasta romperse y luego lo pasa al casco; la distorsión solo agota los escudos. Los escudos solo se regeneran mientras todos los cañones están en pausa más tiempo que su retardo de regeneración, y una vez caídos siguen caídos. Los PV efectivos son el daño bruto de un tipo necesario para destruir la nave, sin deflexión. Los rayos, marcados con TTK, solo cuentan para el tiempo hasta destruir: el blindaje nunca los desvía y, sin alfa por disparo, no entran en el margen. Los misiles se omiten."
      },
      "deflectionCheck": {
        "title": "Comprobación de deflexión",
        "intro": "— ¿qué cañones perforan sus defensas?",
        "noArmor": "Esta nave no lleva blindaje, así que no se desvía nada.",
        "allSizes": "Todos",
        "deflected": "desviados",
        "pierce": "perforan",
        "weapon": "Arma",
        "boundary": "Umbral de deflexión",
        "alpha": "Alpha",
        "threshold": "Umbral superado",
        "absorbed": "absorbidos",
        "versus": "vs",
        "hoverHint": "Pasa el cursor sobre un arma para ver el desglose por tipo.",
        "note": "El alpha se compara por proyectil, después de la absorción del escudo: un cañón perfora cuando supera la deflexión en algún tipo de daño. Los tipos que los escudos absorben por completo nunca llegan al blindaje, por lo que se listan como absorbidos en lugar de desviados: los detiene el escudo, no el casco. La absorción del escudo se interpola dentro de su rango mín.–máx. publicado según la salud del escudo, y la deflexión del blindaje escala linealmente con la salud del blindaje. Los rayos láser quedan excluidos: causan daño continuo, así que no hay un alpha por disparo que comprobar.",
        "margin": "Margen",
        "reachesArmor": "Llega al blindaje",
        "stoppedByShields": "El escudo lo absorbe",
        "verdict": {
          "absorbed": "Absorbido",
          "deflected": "Desviado",
          "pierces": "Perforado"
        },
        "shieldHealth": "Salud del escudo",
        "armorHealth": "Salud del blindaje",
        "absorb": "Absorc.",
        "defl": "Defl",
        "type": "Tipo",
        "size": "Tamaño"
      },
      "hull": {
        "category": {
          "vital": "Vitales",
          "secondary": "Secundarias",
          "breakable": "Rompibles",
          "subpart": "Subpiezas",
          "cosmetic": "Cosméticas"
        },
        "composition": "Composición del casco",
        "door": "Puerta",
        "doors": "Puertas",
        "doorsNote": "Las puertas interiores rompibles son un apartado aparte: tienen su propia salud y no forman parte de los HP del casco.",
        "doorsSub": "%{count} rompibles",
        "hint": "Los HP del casco son la suma de la salud de todas las piezas.",
        "hullHp": "HP del casco",
        "hullHpSub": "total de todas las piezas",
        "integrity": "Integridad del casco",
        "noHp": "sin HP",
        "parts": "Piezas del casco",
        "partsNote": "Las piezas se ordenan por salud; las piezas cosméticas (puertas, escaleras, aletas) no tienen salud propia. Los archivos del juego no exponen vínculos padre/hijo, así que esto es una lista plana y no un árbol estructural.",
        "partsSub": "en %{count} categorías",
        "partsTree": "Piezas · damageMax",
        "showParts": "Mostrar piezas del casco",
        "title": "Casco",
        "totalHp": "HP total del casco"
      },
      "manufacturer": {
        "shortName": "Nombre corto",
        "shipyard": "Astillero",
        "longName": "Nombre completo",
        "code": "Código",
        "logo": "Logo",
        "logoOverridden": "Logo (sobrescrito)",
        "icon": "Icono (archivos del juego)",
        "iconOverridden": "Icono (sobrescrito)",
        "scRef": "SC Ref"
      },
      "announcement": {
        "title": "Título",
        "body": "Cuerpo",
        "discordParts": "Mensajes de Discord",
        "socialParts": "Publicaciones sociales",
        "link": "Enlace",
        "notifyUsers": "Notificación en la app",
        "postDiscord": "Canal de novedades de Discord",
        "postBluesky": "Bluesky",
        "schedule": "Programar",
        "publishAt": "Enviar el"
      },
      "fundingGoal": {
        "title": "Título",
        "description": "Descripción",
        "amount": "Importe",
        "currency": "Moneda",
        "effectiveFrom": "Vigente desde",
        "endedAt": "Finalizado el"
      },
      "supporterContribution": {
        "name": "Nombre del patrocinador",
        "user": "Cuenta vinculada",
        "amount": "Importe",
        "currency": "Moneda",
        "anonymous": "Anónima",
        "recurring": "Recurrente",
        "startedAt": "Iniciada el",
        "endedAt": "Finalizada el",
        "payerEmail": "Correo del pagador",
        "claimKey": "Token de patrocinador",
        "linkedVia": "Vinculada mediante",
        "source": "Origen",
        "note": "Nota interna",
        "stats": {
          "total": "Total",
          "count": "Aportaciones",
          "currentMonth": "Este mes",
          "currentMonthCount": "%{count} aportaciones",
          "recurringCount": "Recurrentes",
          "anonymousCount": "Anónimas"
        },
        "chart": {
          "contributions": "Aportaciones",
          "goal": "Objetivo"
        }
      },
      "itemPrice": {
        "price": "Precio",
        "location": "Ubicación",
        "locationUrl": "URL de ubicación"
      },
      "video": {
        "url": "URL",
        "videoType": "Tipo"
      },
      "modelModule": {
        "slot": "Ranura",
        "noSlot": "Sin ranura",
        "slotsOnHull": "Ranuras de módulo en esta nave: %{slots}",
        "noSlotsOnHull": "Los archivos del juego no dan ranuras de módulo a esta nave; se puede poner cualquier nombre",
        "name": "Nombre",
        "description": "Descripción",
        "price": "Precio",
        "pledgePrice": "Precio Pledge",
        "productionStatus": "Estado de Producción",
        "scKey": "SC Key",
        "storeImage": "Imagen de Tienda",
        "active": "¿Activo?",
        "hidden": "¿Oculto?"
      },
      "dockAddition": {
        "model": "Nave",
        "hint": "Naves que admite este atracadero y que su clase no cubre.",
        "empty": "naves nombradas"
      },
      "dockCapacity": {
        "ladder": "Escala",
        "size": "Clase",
        "quantity": "Cuántos",
        "display": "Mostrar como etiqueta",
        "hint": "Para qué está hecho el atracadero. Las entradas son alternativas, no una suma.",
        "empty": "entradas de capacidad"
      },
      "dockCapacityLadders": {
        "ship": "Naves",
        "vehicle": "Vehículos"
      },
      "vehicleSizes": {
        "extra_extra_small": "Extra extra pequeño (XXS)",
        "extra_small": "Extra pequeño (XS)",
        "small": "Pequeño (S)",
        "medium": "Mediano (M)",
        "large": "Grande (L)",
        "extra_large": "Extra grande (XL)",
        "extra_extra_large": "Extra extra grande (XXL)"
      },
      "dock": {
        "name": "Nombre",
        "dockType": "Tipo de muelle",
        "shipSize": "Tamaño de nave",
        "access": "Acceso",
        "length": "Longitud",
        "beam": "Manga",
        "height": "Altura",
        "unmeasured": "sin medir"
      },
      "modelPosition": {
        "name": "Nombre",
        "positionType": "Tipo de posición",
        "source": "Fuente",
        "position": "Orden",
        "types": {
          "pilot": "Piloto",
          "copilot": "Copiloto",
          "turret_gunner": "Artillero de torreta",
          "engineer": "Ingeniero",
          "gunner": "Artillero",
          "loadmaster": "Jefe de carga",
          "passenger": "Pasajero",
          "operator": "Operador",
          "custom": "Personalizada"
        }
      },
      "modelUpgrade": {
        "name": "Nombre",
        "description": "Descripción",
        "pledgePrice": "Precio de Pledge",
        "active": "¿Activo?",
        "hidden": "¿Oculto?"
      },
      "modelModulePackage": {
        "name": "Nombre",
        "description": "Descripción",
        "pledgePrice": "Precio de Pledge",
        "modules": "Módulos",
        "active": "¿Activo?",
        "hidden": "¿Oculto?"
      },
      "cargoHold": {
        "offsetX": "Offset X (SCU)",
        "offsetY": "Offset Y (SCU)",
        "offsetZ": "Offset Z (SCU)",
        "rotation": "Rotación (°)"
      },
      "modelLoaner": {
        "hidden": "¿Oculto?",
        "loanerModel": "Modelo prestado"
      },
      "modelSnubCraft": {
        "snubCraft": "Snub Craft"
      },
      "modelPaint": {
        "hidden": "¿Oculto?",
        "active": "¿Activo?",
        "onSale": "En venta",
        "pledgePrice": "Precio de Pledge",
        "productionStatus": "Estado de producción",
        "productionNote": "Nota de producción",
        "copyHint": "Selecciona la nave de destino a la que copiar esta pintura. Los datos de la pintura no se modifican durante la copia.",
        "bulkCopyHint": "Selecciona la nave de destino a la que copiar estas %{count} pinturas. Los datos de las pinturas no se modifican durante la copia.",
        "copySameModel": "La nave de destino debe ser distinta de la nave de origen."
      },
      "component": {
        "temperature": {
          "minCooling": "Refrigera desde",
          "overheat": "Se sobrecalienta a",
          "warning": "Aviso a",
          "recovery": "Se recupera a",
          "misfireRange": "Rango de fallo",
          "irStart": "IR desde",
          "irPerKelvin": "IR por K"
        },
        "misfire": {
          "heat": "Calor",
          "distortion": "Distorsión",
          "damage": "Daño",
          "wear": "Desgaste",
          "window": "Ventana",
          "hint": "El nivel de cada estado a partir del cual el componente puede empezar a fallar, según los archivos del juego."
        },
        "availability": {
          "retired": "Los precios se registran para la versión en la que está el catálogo, y esta pieza no está en ella.",
          "craftedOnly": "Ninguna terminal lo vende: se fabrica con la receta de abajo.",
          "none": "Ninguna terminal lo compra ni lo vende."
        },
        "notRecordedYet": "Solo se registra desde que empezó el seguimiento, así que un componente puede no tener nada.",
        "size": "Size: %{size}",
        "grade": "Grado",
        "hidden": "¿Oculto?",
        "componentType": "Tipo de componente",
        "componentSubType": "Subtipo de componente",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image",
        "itemClass": "Clase",
        "category": "Categoría",
        "subType": "Subtipo",
        "retired": "Ya no está en la compilación actual",
        "noMetrics": "No hay métricas registradas para este componente.",
        "durability": {
          "health": "Salud",
          "mass": "Masa",
          "physical": "Físico",
          "energy": "Energía",
          "distortion": "Distorsión",
          "thermal": "Térmico",
          "biochemical": "Bioquímico",
          "stun": "Aturdimiento",
          "repairTime": "Tiempo de reparación",
          "repairsTo": "Repara hasta",
          "maxRepairs": "Reparaciones máx.",
          "disableAt": "Se desactiva en",
          "warningAt": "Aviso en",
          "recoversBelow": "Se recupera por debajo de",
          "decayRate": "Tasa de disipación",
          "decayDelay": "Retardo de disipación"
        },
        "durabilityChanges": {
          "health": "Salud",
          "mass": "Masa (kg)",
          "resistancesPhysical": "Daño físico recibido",
          "resistancesEnergy": "Daño de energía recibido",
          "resistancesDistortion": "Daño de distorsión recibido",
          "resistancesThermal": "Daño térmico recibido",
          "resistancesBiochemical": "Daño bioquímico recibido",
          "resistancesStun": "Daño de aturdimiento recibido",
          "selfRepairTime": "Tiempo de autorreparación (s)",
          "selfRepairHealthRatio": "La autorreparación restaura hasta",
          "selfRepairMaxRepairs": "Autorreparaciones máx.",
          "distortionMaximum": "Umbral de apagado por distorsión",
          "distortionWarningRatio": "Umbral de aviso de distorsión",
          "distortionRecoveryRatio": "Umbral de recuperación de distorsión",
          "distortionDecayRate": "Tasa de disipación de distorsión (/s)",
          "distortionDecayDelay": "Retardo de disipación de distorsión (s)"
        }
      },
      "hardpoint": {
        "legend": {
          "headline": "Leyenda",
          "slotTaken": "Slot ocupado",
          "slotAvailable": "Slot disponible"
        },
        "size": "Tamaño",
        "rackSize": "Tamaño de rack",
        "details": "Detalles",
        "group": "Grupo",
        "thrusters": {
          "thrust": "Empuje",
          "subTypes": {
            "JointThruster": "Joint",
            "FixedThruster": "Fix",
            "FlexThruster": "Flex",
            "Retro": "Fix",
            "Light": "Light"
          },
          "fuelBurn": "Consumo de combustible",
          "mode": "Modo",
          "vtolOnly": "Solo VTOL",
          "vectorPitch": "Vectorización cabeceo",
          "vectorYaw": "Vectorización guiñada"
        },
        "refuelBoom": {
          "captureRadius": "Radio de captura",
          "fuelFlowRate": "Caudal de combustible",
          "quantumFuelFlowRate": "Caudal de combustible Quantum"
        },
        "controllers": {
          "faceType": "Tipo de escudo",
          "faces": {
            "bubble": "Burbuja",
            "quadrant": "Cuadrantes"
          },
          "reconfigurationCooldown": "Reconfiguración",
          "armedMissiles": "Misiles armados",
          "launchCooldown": "Enfriamiento de lanzamiento",
          "lockAngle": "Ángulo de fijación"
        },
        "countermeasureStats": {
          "duration": "Duración",
          "spawnDelay": "Se despliega tras",
          "infrared": "Firma IR",
          "electromagnetic": "Firma EM",
          "crossSection": "Sección transversal"
        },
        "turrets": {
          "turnRate": "Velocidad de giro",
          "control": "Control",
          "yawRange": "Rango de guiñada",
          "pitchRange": "Rango de cabeceo",
          "limitsVary": "según la rotación",
          "gunPorts": "Puertos de armas"
        },
        "weapons": {
          "dps": "DPS",
          "burstDps": "DPS de ráfaga",
          "sustainedDps": "DPS sostenido",
          "efficiency": "Eficiencia",
          "penetration": "Penetración",
          "fireRate": "Cadencia de tiro",
          "speed": "Velocidad",
          "range": "Alcance",
          "ammo": "Munición",
          "ammoCost": "Coste de munición",
          "magazineDamage": "Daño del cargador",
          "timeToEmpty": "Tiempo hasta vaciar",
          "spread": "Dispersión",
          "spreadFirstShot": "Dispersión del primer disparo",
          "spreadPerShot": "Dispersión/disparo",
          "spreadRecovery": "Recuperación de dispersión",
          "pool": "Reserva de energía",
          "maxRegen": "Regen máx./s",
          "costPerShot": "Energía/disparo",
          "heatPerShot": "Calor/disparo",
          "heatPerSecond": "Calor/s",
          "gimbalFireRate": "Cadencia (gimbal)",
          "gimbalSpread": "Dispersión (gimbal)",
          "spreadMin": "mín.",
          "spreadMax": "máx.",
          "aimAssist": "Asistencia de puntería",
          "closeAimAssist": "Asistencia a corta distancia",
          "chargeTime": "Tiempo de carga",
          "fullDamageRange": "Alcance DMG máx.",
          "zeroDamageRange": "Alcance DMG nulo",
          "damagePhysical": "Físico",
          "damageEnergy": "Energía",
          "damageDistortion": "Distorsión",
          "damageThermal": "Térmico"
        },
        "missiles": {
          "damage": "Daño",
          "speed": "Velocidad",
          "range": "Alcance",
          "lockRange": "Alcance de fijación",
          "lockTime": "Tiempo de fijación",
          "trackingSignal": "Rastreo",
          "lockAngle": "Cono de fijación",
          "signalResilience": "Resistencia de señal",
          "boostPhase": "Fase de impulso",
          "terminalPhase": "Fase terminal",
          "lifetime": "Vida útil",
          "fuel": "Combustible",
          "dumbfire": "Disparo sin guía",
          "dumbfireAllowed": "Permitido",
          "dumbfireBlocked": "No permitido",
          "blastRadius": "Radio de explosión",
          "armTime": "Tiempo de armado",
          "safetyDistance": "Distancia de seguridad"
        },
        "bombs": {
          "maxDropAngle": "Ángulo máx. de lanzamiento"
        },
        "missileRacks": {
          "launchDelay": "Retardo de lanzamiento",
          "ignition": "Encendido del motor",
          "ignitesOnRack": "En el soporte",
          "ignitesAfterRelease": "Tras la liberación"
        },
        "tractorBeams": {
          "maxForce": "Fuerza máx.",
          "minForce": "Fuerza mín.",
          "range": "Alcance",
          "cone": "Cono",
          "tetherBreak": "Ruptura de amarre",
          "cargoForce": "Fuerza de carga",
          "cargoRange": "Alcance de carga",
          "towForce": "Fuerza de remolque",
          "towDistance": "Alcance de remolque",
          "quantumTowMass": "Límite de masa QT",
          "rotationSpeed": "Rotación",
          "moveSpeed": "Velocidad de movimiento"
        },
        "shields": {
          "hp": "HP",
          "regen": "Regen",
          "regenTime": "Tiempo de regen",
          "downedRegenDelay": "Retardo tras caída",
          "damagedRegenDelay": "Retardo tras daño",
          "resistancePhysical": "Resist. fís.",
          "resistanceEnergy": "Resist. energía",
          "resistanceDistortion": "Resist. distors.",
          "decay": "Decaimiento",
          "absorption": {
            "physical": "Absorción física",
            "energy": "Absorción de energía",
            "distortion": "Absorción de distorsión"
          }
        },
        "coolers": {
          "coolingRate": "Refrigeración"
        },
        "powerPlants": {
          "output": "Potencia",
          "pips": "Pips"
        },
        "flightControllers": {
          "scmSpeed": "Velocidad SCM",
          "boostSpeed": "Velocidad de impulso",
          "navSpeed": "Velocidad Nav",
          "rotation": "Cabeceo / Guiñada / Alabeo",
          "boostedRotation": "Cabeceo / Guiñada / Alabeo con impulso",
          "boostCapacity": "Capacidad de impulso",
          "boostRegen": "Regeneración de impulso",
          "boostRegenDelay": "Retardo de regeneración de impulso",
          "boostRamp": "Arranque / parada del impulso"
        },
        "quantumDrives": {
          "speed": "Velocidad",
          "range": "Alcance",
          "fuelConsumption": "Consumo",
          "spoolUpTime": "Preparación",
          "cooldownTime": "Enfriamiento",
          "splineSpeed": "Órbita",
          "accel": "Acel.",
          "engageSpeed": "Velocidad de enganche",
          "calibrationRate": "Velocidad de calibración",
          "disconnectRange": "Distancia de desconexión",
          "interdictionTime": "Tiempo de interdicción",
          "splineAccel": "Aceleración en órbita",
          "splineSpoolUpTime": "Carga en órbita",
          "splineCooldownTime": "Enfriamiento en órbita",
          "splineInterdictionTime": "Interdicción en órbita",
          "jumpHeat": "Calor de salto"
        },
        "jumpDrives": {
          "fuelEfficiency": "Eficiencia de combustible",
          "alignRate": "Tasa de alineación",
          "tuneRate": "Tasa de sintonía",
          "alignDecay": "Decaimiento de alineación",
          "tuneDecay": "Decaimiento de sintonía",
          "exitSpeed": "Velocidad de salida",
          "maxTunnelSpeed": "Velocidad máx. en túnel",
          "respoolTime": "Recarga"
        },
        "radar": {
          "aimAssistRange": "Alcance de asistencia",
          "ir": "IR",
          "em": "EM",
          "cs": "CS",
          "rs": "RS",
          "passive": "Detección pasiva",
          "active": "Detección activa",
          "aimAssistBuffer": "Margen de asistencia",
          "sensitivityModifier": "Modificador de sensibilidad",
          "contactGroups": {
            "GroundVehicle": "Vehículos terrestres"
          }
        },
        "armor": {
          "hp": "HP",
          "physical": "Físico",
          "energy": "Energía",
          "distortion": "Distorsión",
          "thermal": "Térmico",
          "deflectPhysical": "Defl. fís.",
          "deflectEnergy": "Defl. energía",
          "selfPhysical": "Autorres. fís.",
          "selfEnergy": "Autorres. energía"
        },
        "fuelIntakes": {
          "pushRate": "Tasa de empuje",
          "minRate": "Tasa mín."
        },
        "sources": {
          "game_files": "Archivos del juego",
          "ship_matrix": "Ship Matrix"
        },
        "density": {
          "title": "Vista",
          "compact": "Compacta",
          "expanded": "Expandida"
        },
        "fuelTanks": {
          "hydrogen": "Tanque de combustible de hidrógeno",
          "quantum": "Tanque de combustible Quantum"
        },
        "jumpDrive": "Motor de salto",
        "maxContainerSize": "Tamaño máx. de contenedor",
        "groups": {
          "avionic": "Aviónica",
          "system": "Sistemas",
          "propulsion": "Propulsión",
          "thruster": "Propulsor",
          "weapon": "Armas",
          "defense": "Defensa",
          "other": "Carga",
          "auxiliary": "Auxiliar",
          "seat": "Asientos",
          "external_fuel_tank": "Tanques de combustible externos",
          "ore_pod": "Contenedores de mineral",
          "module": "Módulos",
          "salvage": "Salvamento",
          "refuel_boom": "Brazo de repostaje"
        },
        "types": {
          "radar": "Radar",
          "computers": "Computadoras",
          "power_plants": "Plantas de energía",
          "coolers": "Enfriadores",
          "shield_generators": "Generadores de escudo",
          "fuel_intakes": "Tomas de combustible",
          "fuel_tanks": "Tanques de combustible",
          "quantum_drives": "Motores Quantum",
          "jump_modules": "Módulos de salto",
          "jumpdrive": "Módulos de salto",
          "quantum_fuel_tanks": "Tanques de combustible Quantum",
          "main_thrusters": "Propulsores principales",
          "maneuvering_thrusters": "Propulsores de maniobra",
          "weapons": "Armas",
          "turrets": "Torretas",
          "missiles": "Misiles",
          "utility_items": "Objetos de utilidad",
          "utility": "Objetos de utilidad",
          "emp": "EMP",
          "qed": "QED"
        },
        "moduleSlotEmpty": "— Seleccionar módulo —",
        "selectModule": "Seleccionar módulo",
        "moduleStock": "Tal como se entrega",
        "moduleStockHint": "Ranura tal como viene la nave",
        "categories": {
          "radar": "Radar",
          "armor": "Blindaje",
          "relay": "Relé",
          "countermeasures": "Contramedidas",
          "lifesupport": "Soporte vital",
          "selfdestruct": "Autodestrucción",
          "batteries": "Baterías",
          "computers": "Computadoras",
          "powerplant": "Plantas de energía",
          "cooler": "Enfriadores",
          "module": "Módulos",
          "shieldgenerator": "Generadores de escudo",
          "fuel_intakes": "Tomas de combustible",
          "fueltanks": "Tanques de combustible",
          "external_fuel_tanks": "Tanques de combustible externos",
          "ore_pods": "Contenedores de mineral",
          "salvage_storage": "Almacén de chatarra",
          "refuel_boom": "Brazo de repostaje",
          "quantumdrive": "Motores Quantum y módulos de salto",
          "jump_modules": "Módulos de salto",
          "jumpdrive": "Módulos de salto",
          "quantum_fuel_tanks": "Tanques de combustible Quantum",
          "main_thrusters": "Propulsores principales",
          "maneuvering_thrusters": "Propulsores de maniobra",
          "retro_thrusters": "Propulsores retro",
          "vtol_thrusters": "Propulsores VTOL",
          "weapons": "Armas",
          "weapon_mounts": "Soportes de armas",
          "turret": "Torretas",
          "missiles": "Misiles",
          "missile_racks": "Racks de misiles",
          "utility_items": "Objetos de utilidad",
          "utility": "Objetos de utilidad",
          "emp": "EMP",
          "quantumenforcementdevice": "QED",
          "salvagefillerstation": "Estación de llenado de salvamento",
          "cargogrid": "Grilla de carga",
          "controller": "Cuchillas de vuelo",
          "seat": "Asientos",
          "thrusters": "Propulsores",
          "bombcompartments": "Compartimentos de bombas"
        },
        "name": "Nombre",
        "category": "Categoría",
        "source": "Fuente",
        "powerConsumption": "Consumo de energía",
        "powerMinimumFraction": "Consumo en reposo",
        "signatureEm": "Firma EM",
        "signatureIr": "Firma IR",
        "mining": {
          "fracturePower": "Potencia de fractura",
          "extractionPower": "Potencia de extracción",
          "range": "Alcance",
          "chargeTime": "Carga / descarga",
          "moduleSlots": "Ranuras de módulo",
          "activation": "Tipo",
          "active": "Activo",
          "passive": "Pasivo",
          "charges": "Usos",
          "duration": "Duración",
          "modifiers": {
            "instability": "Inestabilidad",
            "resistance": "Resistencia",
            "optimalChargeWindow": "Ventana de carga óptima",
            "optimalChargeRate": "Tasa de carga óptima",
            "catastrophicChargeRate": "Tasa de carga catastrófica",
            "shatterDamage": "Daño por fragmentación",
            "inertMaterials": "Materiales inertes"
          }
        },
        "salvage": {
          "salvageSpeed": "Velocidad de recuperación",
          "radius": "Radio del haz",
          "extractionEfficiency": "Eficiencia de extracción"
        },
        "utility": {
          "capacity": "Capacidad"
        },
        "selfDestruct": {
          "damage": "Daño",
          "radius": "Radio de explosión",
          "time": "Tiempo de detonación"
        },
        "quantumEnforcement": {
          "jammerRange": "Alcance del inhibidor",
          "pulseRadius": "Radio del pulso",
          "chargeTime": "Tiempo de carga",
          "cooldownTime": "Enfriamiento"
        },
        "emp": {
          "distortionDamage": "Daño de distorsión",
          "radius": "Radio",
          "chargeTime": "Tiempo de carga",
          "unleashTime": "Tiempo de descarga",
          "cooldownTime": "Enfriamiento"
        },
        "lifeSupport": {
          "output": "Producción"
        },
        "powerRanges": "Curva de potencia (baja / media / alta)",
        "powerSegments": "seg."
      },
      "blank": {
        "propulsion": "Sin propulsión presente",
        "modular": "Sin módulo presente",
        "fleetInvites": "Sin invitaciones presentes"
      },
      "user": {
        "displayName": "Nombre visible",
        "displayNameInfo": "Se muestra en lugar de tu nombre de usuario en tu hangar público, en tus placas de dedicatoria y en las listas de miembros de las flotas.",
        "hangarDefaultSort": "Orden predeterminado",
        "hangarDefaultSortInfo": "Arrastra una nave por su asa para reordenarla. Disponible mientras el orden personalizado esté activo y no haya filtros.",
        "hangarDefaultSortOptions": {
          "standard": "Estándar (nave insignia primero, luego nombre)",
          "asc": "%{field}, ascendente",
          "desc": "%{field}, descendente"
        },
        "rsiHandle": "Handle",
        "rsiHandleVerified": "Verificado mediante Citizen iD",
        "rsiHandleVerifiedViaProfile": "Verificado mediante el perfil de RSI",
        "rsiVerification": {
          "title": "Verifica tu handle de RSI",
          "token": "Código de verificación",
          "verifiedSince": "Verificado desde %{date}",
          "openProfileSettings": "Editar tu perfil de RSI",
          "steps": {
            "copy": "Copia tu código de verificación",
            "paste": "Pégalo en la biografía breve de tu perfil de RSI. Puedes quitarlo cuando tu handle esté verificado.",
            "check": "Comprueba la página de ciudadano de %{handle}"
          },
          "extension": {
            "title": "Verificar con la extensión FleetYards Sync",
            "verify": "Verificar con la extensión",
            "description": "La extensión añade tu código a la biografía de la cuenta de RSI con la que este navegador ha iniciado sesión, comprueba tu página de ciudadano y vuelve a quitar el código.",
            "detecting": "Buscando la extensión FleetYards Sync",
            "install": "Instala la extensión FleetYards Sync para verificar tu handle con un clic.",
            "update": "Actualiza la extensión FleetYards Sync para verificar tu handle con un clic: la versión instalada aún no lo admite.",
            "handleMismatch": "Este navegador ha iniciado sesión en RSI como %{rsiHandle}, no como %{handle}. Inicia sesión en RSI como %{handle} o verifica a mano más abajo.",
            "notSignedIn": "Inicia sesión en RSI en este navegador para verificar con la extensión, o verifica a mano más abajo.",
            "bioTooLong": "Tu biografía de RSI es demasiado larga para añadir el código. Acórtala o verifica a mano más abajo.",
            "bioUnreadable": "Tu biografía de RSI tiene un formato que la extensión no puede conservar tal cual. Verifica a mano más abajo.",
            "failed": "La extensión no pudo actualizar tu biografía de RSI. Inténtalo de nuevo o verifica a mano más abajo.",
            "removeFailed": "La extensión no pudo quitar el código de tu biografía de RSI. Quítalo allí a mano.",
            "manual": "O verifica a mano:"
          },
          "statuses": {
            "pending": "Comprobando tu página de ciudadano…",
            "token_missing": "El código aún no está en tu biografía. RSI puede tardar unos minutos en mostrar un cambio.",
            "handle_mismatch": "La página que devolvió RSI pertenece a otro handle.",
            "not_found": "RSI no tiene ningún ciudadano con este handle.",
            "failed": "No se pudo comprobar tu página de ciudadano. Inténtalo de nuevo en un minuto."
          }
        },
        "location": "Ubicación",
        "currentSystem": "Ubicación actual en el juego",
        "tester": "¿Tester?",
        "maintainer": "¿Mantenedor?",
        "avatar": "Avatar",
        "unconfirmedEmail": "Correo electrónico no confirmado",
        "saleNotify": "Deseo recibir notificaciones de ventas",
        "publicHangar": "Hangar público habilitado",
        "publicHangarLoaners": "Mostrar indicación de préstamos en hangar público",
        "publicHangarStats": "Estadísticas de hangar público habilitadas",
        "publicWishlist": "Lista de deseos pública habilitada",
        "hideOwner": "Ocultar propiedad para flotas",
        "tracking": "Permitir analíticas de uso anónimas",
        "showOnlineStatus": "Mostrar cuándo estoy en línea",
        "supporterListed": "Página de colaboradores",
        "supporterListedPlatform": "Según lo elegido al donar",
        "supporterListedShown": "Mostrar mi nombre de usuario",
        "supporterListedHidden": "No mostrarme",
        "onlineStatus": "Estado en línea",
        "online": "En línea",
        "offline": "Desconectado",
        "lastActiveAt": "Última actividad",
        "confirmedAt": "Confirmado el",
        "dateFormat": "Formato de fecha",
        "dateFormats": {
          "dmy_dots": "31.12.2026",
          "dmy_slash": "31/12/2026",
          "mdy_slash": "12/31/2026",
          "ymd_dash": "2026-12-31"
        },
        "friendsHangar": "Hangar visible para los amigos",
        "friendsHangarStats": "Estadísticas del hangar visibles para los amigos",
        "friendsWishlist": "Lista de deseos visible para los amigos"
      },
      "adminUser": {
        "superAdmin": "Super administrador",
        "passwordConfirmation": "Confirmación de contraseña"
      },
      "vehicle": {
        "customOrder": "Personalizado",
        "name": "Nombre",
        "states": "Estados",
        "serial": "Serie",
        "owner": "comandado por",
        "flagship": "Nave insignia",
        "wanted": "Deseado",
        "loaner": "Prestado",
        "bundled": "Incluida en un paquete",
        "bundledWith": "Incluida con %{parent}",
        "hiddenByUser": "Oculta de tu hangar",
        "public": "Visible públicamente",
        "fullPublic": "Visible públicamente incluyendo nombre",
        "publicShort": "Público",
        "saleNotifyOn": "Notificaciones de venta activadas",
        "saleNotifyOff": "Notificaciones de venta desactivadas",
        "nameVisible": "Visible públicamente",
        "hidden": "¿Oculto?",
        "saleNotify": "Deseo recibir notificaciones de ventas",
        "hangarGroups": "Grupos",
        "ownedPaintsSelect": {
          "label": "Pinturas propias",
          "pledged": "De un pledge",
          "empty": "No se encontraron pinturas"
        },
        "modelPaintSelect": {
          "nullablePrompt": "Seleccionar una pintura",
          "label": "Pintura"
        },
        "bulkGroupEdit": {
          "hint": "¡Los grupos existentes serán reemplazados!"
        },
        "hasLoaners": "Prestados",
        "boughtViaSelect": {
          "label": "Comprado mediante"
        }
      },
      "image": {
        "active": "¿Activo?",
        "background": "¿Usar como fondo?",
        "caption": "Descripción",
        "enabled": "¿Habilitado?",
        "file": "Archivo de imagen",
        "global": "¿Global?",
        "delete": "Eliminar",
        "start": "Iniciar",
        "cancel": "Cancelar",
        "processing": "Procesando...",
        "error": "Error",
        "name": "Nombre",
        "size": "Tamaño de archivo",
        "dropzone": "Soltar imágenes aquí",
        "cancelUpload": "Cancelar subida",
        "startUpload": "Iniciar subida",
        "selectImages": "Agregar imágenes...",
        "selectFolder": "Agregar una carpeta..."
      },
      "signup": {
        "link": "¿No tiene una cuenta?",
        "privacyPolicy": "Al crear una cuenta en FleetYards, acepta nuestra"
      },
      "privacyPolicy": "Política de privacidad",
      "login": "Nombre de usuario o correo electrónico",
      "username": "Nombre de usuario",
      "twoFactorCode": "Código de dos factores",
      "confirmationCode": "Código de confirmación",
      "email": "Correo electrónico",
      "avatar": "Avatar",
      "alreadyRegistered": "¿Ya tiene una cuenta?",
      "password": "Contraseña",
      "passwordConfirmation": "Confirmación de contraseña",
      "rememberMe": "Recordarme",
      "emptyList": "No hay %{name} presente",
      "all": "Todos",
      "supportUs": "Support FleetYards.net",
      "account": {
        "destroyInfo": "If you want to delete Your Account and remove all your Information from Fleetyards.net and its Services click the Button below. Be aware of that this is a permanent Action and can't be reverted.",
        "calendarSubscription": {
          "intro": "Genera un enlace privado para añadir los eventos a los que te has inscrito a tu aplicación de calendario personal (Apple Calendar, Google Calendar, Outlook).",
          "howTo": "Pega el enlace en tu aplicación de calendario en \"Suscribirse al calendario\" o \"Añadir por URL\". Cualquiera que tenga este enlace puede ver los eventos a los que estás inscrito: mantenlo en privado."
        },
        "supporterNomination": {
          "label": "Apoyo a la flota",
          "hint": "Sus miembros obtienen las funciones de flota mientras una donación esté activa. Puedes elegir antes de donar.",
          "perDonation": "Por donación",
          "perDonationHint": "Una donación puede apoyar una flota distinta de la habitual.",
          "fleet": "Flota apoyada"
        },
        "supporterClaimKey": {
          "signedOut": "Inicia sesión para obtener tu clave personal de patrocinador.",
          "patreonNote": "se asocia mediante tu correo, no hace falta clave",
          "label": "Tu clave",
          "hint": "Pégala en el mensaje de un pago por PayPal, Ko-fi o Buy me a coffee y se asociará a tu cuenta. En Patreon la asociación se hace por correo electrónico.",
          "listed": "Tú decides si tu nombre de usuario aparece en la página de colaboradores:",
          "listedLink": "Ajustes de privacidad"
        }
      },
      "filters": {
        "locations": {
          "name": "Buscar ubicaciones",
          "system": "Sistema",
          "parent": "Dentro de",
          "kind": "Tipo",
          "starmap": "Mapa del juego",
          "shownOnStarmap": "Visible en el mapa",
          "hiddenOnStarmap": "Oculto en el mapa"
        },
        "components": {
          "name": "Nombre",
          "buyPriceGt": "Precio de compra >=",
          "buyPriceLt": "Precio de compra <=",
          "sellPriceGt": "Precio de venta >=",
          "sellPriceLt": "Precio de venta <=",
          "storeImageBlank": "¿Sin imagen de tienda?",
          "description": "Descripción",
          "manufacturer": "Fabricante",
          "category": "Categoría",
          "subType": "Subtipo"
        },
        "shops": {
          "name": "Nombre",
          "type": "Tipo",
          "model": "Nave",
          "equipment": "Equipamiento",
          "component": "Componente",
          "commodity": "Mercancía",
          "commodityType": "Tipo de mercancía"
        },
        "shopCommodities": {
          "commodityType": "Tipo de mercancía",
          "equipment": "Equipamiento",
          "component": "Componente",
          "commodity": "Mercancía",
          "model": "Nave",
          "name": "Nombre"
        },
        "shopItems": {
          "category": "Categoría",
          "subCategory": "Subcategoría",
          "name": "Nombre",
          "manufacturer": "Fabricante"
        },
        "stations": {
          "name": "Nombre",
          "type": "Tipo de estación",
          "shops": "Tiendas",
          "docks": "Muelles"
        },
        "vehicles": {
          "name": "Name or Ship name",
          "lengthLt": "Length <=",
          "lengthGt": "Length >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "Precio <=",
          "priceGt": "Precio >=",
          "wanted": "Deseado",
          "hidden": "Oculto",
          "public": "Público",
          "group": "Grupo",
          "loaner": "Prestados",
          "bundled": "Snub Crafts incluidos en un paquete",
          "hiddenByUser": "Naves ocultas",
          "boughtVia": "¿Comprado mediante?",
          "image": "Imagen",
          "imageSources": {
            "custom": "No predeterminada",
            "upload": "Subida",
            "gallery": "De la galería",
            "default": "Predeterminada"
          },
          "dedication": "Placa de dedicatoria"
        },
        "models": {
          "name": "Nombre",
          "classification": "Clasificación",
          "focus": "Enfoque",
          "manufacturer": "Fabricante",
          "onSale": "En venta",
          "ingameOnly": "Solo en el juego",
          "canLandOnPlanets": "Puede aterrizar en planetas",
          "size": "Tamaño",
          "dockSize": "Tamaño de muelle",
          "price": "Precio",
          "pledgePrice": "Precio de Pledge",
          "productionStatus": "Estado de producción",
          "lengthLt": "Length <=",
          "lengthGt": "Length >=",
          "beamLt": "Beam <=",
          "beamGt": "Beam >=",
          "heightLt": "Height <=",
          "heightGt": "Height >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "Precio <=",
          "priceGt": "Precio >=",
          "willItFit": "Will it Fit?",
          "withCargo": "¿Con carga?",
          "scKeyBlank": "¿Sin SC Key?",
          "positionsNeedCuration": "¿Posiciones que necesitan curación?",
          "fleetchartImageBlank": "¿Sin imagen de gráfico de flota?",
          "holoBlank": "¿Sin Holo?",
          "frontViewBlank": "¿Sin imagen de vista frontal?",
          "topViewColoredBlank": "¿Sin imagen de vista superior a color?",
          "vehicleSize": "Tamaño de vehículo",
          "dimensionsDrifted": "Dimensiones difieren de los archivos del juego",
          "dimensionsMeasuredAtNull": "¿Sin dimensiones medidas?"
        },
        "modelModules": {
          "name": "Nombre"
        },
        "manufacturers": {
          "name": "Nombre",
          "withModels": "Con modelos",
          "logoBlank": "Sin logo"
        },
        "supporterContributions": {
          "name": "Buscar por nombre",
          "recurring": "Recurrente",
          "anonymous": "Anónima",
          "startedAtGteq": "Iniciada desde",
          "startedAtLteq": "Iniciada hasta",
          "user": "Cuenta vinculada",
          "linked": "Vínculo de cuenta",
          "linkedOnly": "Vinculada",
          "linkedVia": "Vinculada mediante",
          "unlinkedOnly": "Sin vincular",
          "sourceStated": "Plataforma indicada",
          "sourceStatedOnly": "Plataforma indicada",
          "sourceUnspecifiedOnly": "Plataforma sin indicar",
          "source": "Origen"
        },
        "adminNotifications": {
          "search": "Buscar"
        },
        "images": {
          "model": "Nave"
        },
        "users": {
          "search": "Buscar",
          "username": "Nombre de usuario",
          "email": "Correo electrónico",
          "rsiHandle": "Handle de RSI"
        },
        "fleets": {
          "name": "Nombre",
          "fid": "FID",
          "memberCountGteq": "Mínimo de miembros",
          "memberCountLteq": "Máximo de miembros",
          "rsiVerified": "Verificada en RSI",
          "publicFleet": "Pública",
          "recruiting": "Reclutando",
          "createdOnGteq": "Creada desde",
          "createdOnLteq": "Creada hasta",
          "member": "Miembro",
          "members": {
            "search": "Nombre de usuario o apodo",
            "role": "Rol",
            "state": "Estado",
            "acceptedAtGt": "Unido desde",
            "acceptedAtLt": "Unido hasta",
            "invitedAtGt": "Invitado desde",
            "invitedAtLt": "Invitado hasta",
            "requestedAtGt": "Solicitado desde",
            "requestedAtLt": "Solicitado hasta",
            "declinedAtGt": "Rechazado desde",
            "declinedAtLt": "Rechazado hasta",
            "inactiveSince": "Inactivo desde",
            "verified": "Organización de RSI",
            "verifiedYes": "Verificado",
            "verifiedNo": "No verificado",
            "withoutRsiHandle": "Sin handle de RSI",
            "withoutDiscord": "Sin Discord vinculado",
            "withoutSquadron": "Sin escuadrón"
          },
          "inviteUrls": {
            "expiresAfter": "Expire after",
            "limit": "Max number of uses"
          },
          "logistics": {
            "search": "Buscar objetos..."
          }
        },
        "manufacturer": "Fabricante",
        "commodities": {
          "description": "Descripción",
          "traded": "Comerciada en algún sitio",
          "name": "Name",
          "commodityType": "Commodity Type",
          "uexCode": "UEX Code",
          "buyPriceGt": "Precio de compra >=",
          "buyPriceLt": "Precio de compra <=",
          "sellPriceGt": "Precio de venta >=",
          "sellPriceLt": "Precio de venta <=",
          "storeImageBlank": "¿Sin imagen de tienda?"
        },
        "equipment": {
          "name": "Nombre",
          "equipmentType": "Tipo de equipo",
          "itemType": "Tipo de objeto",
          "weaponClass": "Clase de arma",
          "slot": "Ranura",
          "size": "Tamaño",
          "grade": "Grado",
          "buyPriceGt": "Precio de compra >=",
          "buyPriceLt": "Precio de compra <=",
          "sellPriceGt": "Precio de venta >=",
          "sellPriceLt": "Precio de venta <=",
          "storeImageBlank": "¿Sin imagen de tienda?",
          "subType": "Subtipo"
        },
        "notifications": {
          "search": "Buscar"
        },
        "blueprints": {
          "org": "Lo entrega",
          "scKey": "Clave del juego",
          "withKnownSource": "Tiene una fuente conocida",
          "withCraftable": "Resultado en un catálogo",
          "currentVersion": "En la compilación actual",
          "name": "Buscar planos",
          "craftableType": "Produce",
          "source": "Fuente",
          "withSource": "Con fuente conocida",
          "withoutSource": "Sin fuente conocida",
          "alignment": "Alineación de la fuente",
          "material": "Usa material",
          "ownedFilter": "En posesión",
          "owned": "En posesión",
          "notOwned": "Sin poseer"
        },
        "missions": {
          "location": "Ubicación",
          "ship": "Tu nave",
          "name": "Buscar misiones",
          "org": "Ofrecida por",
          "standing": "Reputación",
          "rewarding": "Paga",
          "alignment": "Lado de la ley",
          "kind": "Tipo",
          "releasedFilter": "En la versión",
          "released": "En la versión",
          "unreleased": "Fuera de la versión"
        },
        "fleetDirectory": {
          "search": "Nombre, FID o SID",
          "memberCountGteq": "Mínimo de miembros",
          "activity": "Actividad",
          "language": "Idioma",
          "alignment": "Alineamiento",
          "commitment": "Compromiso",
          "timezone": "Zona horaria",
          "recruiting": "Solo reclutando",
          "roleplay": "Solo rol"
        }
      },
      "station": {
        "docks": "Muelles",
        "location": "Ubicación",
        "type": "Tipo",
        "shops": "Tiendas",
        "locationPrefix": {
          "default": "on",
          "orbit": "in orbit around"
        }
      },
      "tradeRoutes": {
        "intro": "El mejor viaje entre dos terminales para tu nave, tu presupuesto y la antigüedad de precios que aceptes. Los precios vienen de UEX y se actualizan cada hora.",
        "yourRun": "Tu viaje",
        "ship": "Nave",
        "noShip": "Elige una nave para ordenar por beneficio por viaje",
        "noShipShort": "Sin nave",
        "scu": "%{count} SCU",
        "budget": "Presupuesto",
        "budgetPlaceholder": "Opcional",
        "buyIn": "Comprar en",
        "anySystem": "Todos",
        "commodity": "Materia prima",
        "allCommodities": "Todas las materias primas",
        "priceAge": "Precios de como máximo",
        "priceAges": {
          "day": "24 h",
          "threeDays": "3 días",
          "any": "Cualquiera"
        },
        "bestRun": "Mejor viaje",
        "buyAt": "Comprar en",
        "sellAt": "Vender en",
        "pricePerScu": "%{price} aUEC / SCU",
        "distanceValue": "%{count} Gm",
        "jumpTo": "salto a %{system}",
        "pricesFrom": "Precios de %{time}",
        "otherBuyers": {
          "one": "+%{count} comprador más",
          "other": "+%{count} compradores más"
        },
        "profitThisRun": "Beneficio del viaje",
        "profitPerScu": "Beneficio por SCU",
        "aUecPerScu": "aUEC · %{value} por SCU",
        "load": "Carga",
        "loadOf": "%{load} de %{cargo} SCU",
        "thisShip": "Esta nave",
        "unflyable": {
          "origin": "%{ship} no puede aterrizar en %{terminal}",
          "destination": "%{ship} no puede aterrizar en %{terminal}",
          "both": "%{ship} no puede aterrizar en ningún extremo"
        },
        "loadLimits": {
          "hold": "Bodega llena",
          "stock": "Limitado por existencias",
          "demand": "Limitado por demanda",
          "budget": "Limitado por presupuesto"
        },
        "youSpend": "Gastas",
        "pickShipForRun": "Elige una nave para ver el beneficio de un viaje.",
        "moreRuns": "Más viajes",
        "runs": "Viajes",
        "rankBy": "Ordenar por",
        "profitPerRun": "Beneficio por viaje",
        "profitPerDistance": "Beneficio por Gm",
        "shortest": "Más corto",
        "buySell": "Compra → venta",
        "spend": "Gasto",
        "distance": "Distancia",
        "prices": "Precios",
        "profit": "Beneficio",
        "to": "a",
        "everyBuyer": "Todos los compradores de %{commodity} desde %{terminal}",
        "empty": "Ningún viaje coincide. Prueba con precios más antiguos u otro sistema.",
        "loadExplained": "La carga usa los tamaños de caja que aceptan ambas terminales y la mercancía, limitada por las existencias donde compras, la demanda donde vendes y tu presupuesto.",
        "poweredByUex": "Precios de UEX"
      },
      "hardpoints": {
        "prefix": "Probar configuraciones con",
        "erkul": "Erkul's DPS Calculator",
        "spviewer": "SP Viewer",
        "spviewerTitle": "SC Ships Performances Viewer",
        "metricsCredit": "Métricas basadas en las fórmulas de"
      },
      "scunpacked": {
        "prefix": "Loadouts based on Gamefiles powered by",
        "link": "SCunpacked"
      },
      "newVehicle": {
        "nullablePrompt": "Seleccionar una nave"
      },
      "table": {
        "selected": "%{count} seleccionados",
        "selectRow": "Seleccionar fila",
        "selectAll": "Seleccionar todas las filas"
      },
      "commodityPrice": {
        "item": "ShopCommodity",
        "price": "Precio",
        "type": "Tipo",
        "shop": "Tienda"
      },
      "hangarPledgeItems": {
        "openOnRsi": "Abrir en el hangar de RSI",
        "flair": "Decoración de hangar",
        "upgrades": "Mejoras / CCU",
        "equipment": "Equipo FPS",
        "createdOn": "Creado",
        "meltable": "Fundible",
        "withValue": "Con valor de fundición",
        "paints": "Pinturas",
        "pledge": "Pledge %{id}",
        "meltValue": "Valor de fundición",
        "partOf": "Parte de %{name}",
        "pledgeValue": "Valor del pledge",
        "quantity": "Cantidad",
        "search": "Buscar por nombre"
      },
      "buybacks": {
        "name": "Pledges de recompra",
        "search": "Buscar pledges de recompra",
        "kind": "Tipo",
        "kinds": {
          "package": "Paquete",
          "ship": "Nave individual",
          "upgrade": "Mejora",
          "paint": "Pintura",
          "addon": "Complemento",
          "other": "Otro"
        },
        "upgraded": "Mejorado",
        "reclaimedOn": "Fundido",
        "notAvailable": "No disponible",
        "price": "Precio",
        "insurance": "Seguro",
        "lifetimeInsurance": "LTI",
        "noInsurance": "Sin seguro",
        "insuranceMonths": {
          "one": "%{count} mes",
          "other": "%{count} meses"
        },
        "openOnRsi": "Recomprar en RSI",
        "remove": "Quitar",
        "priceRange": "Rango de precios",
        "priceMin": "Precio mín. (USD)",
        "priceMax": "Precio máx. (USD)",
        "upgradeFrom": "Mejora desde",
        "upgradeTo": "Mejora a",
        "gets": "Te consigue la nave"
      },
      "buybackSync": {
        "extensionVersion": "Versión instalada de la extensión",
        "detailsProgress": "Leyendo precios de recompra",
        "pages": "Páginas",
        "found": "Pledges de recompra encontrados",
        "added": "Nuevos",
        "removed": "Eliminados",
        "prices": "Precios leídos",
        "background": {
          "finished": "Sincronización de recompras terminada",
          "incomplete": "Sincronización de recompras terminada, faltan algunos precios",
          "unsupported": "La sincronización de recompras necesita una extensión más reciente",
          "failed": "La sincronización de recompras ha fallado"
        },
        "status": {
          "fetching": "Leyendo páginas de recompra",
          "submitting": "Guardando",
          "finished": "Finalizado",
          "unsupported": "No compatible",
          "failed": "Fallido"
        }
      },
      "syncExtension": {
        "warnings": "Avisos",
        "backgroundProgress": "Sincronizando tu hangar",
        "backgroundFinished": "Sincronización del hangar terminada",
        "backgroundFailed": "La sincronización del hangar ha fallado",
        "backgroundCancelled": "Sincronización del hangar cancelada",
        "status": {
          "started": "Importación iniciada...",
          "finished": "Importación finalizada",
          "failed": "¡Importación fallida!",
          "cancelled": "Importación cancelada"
        },
        "processSteps": {
          "fetchHangar": "Obteniendo datos del hangar RSI",
          "submitData": "Enviando datos al backend de Fleetyards.net"
        },
        "sessionStatus": "Estado de sesión RSI",
        "signedInAs": "Sesión iniciada en RSI como %{handle}",
        "signInToRsi": "Iniciar sesión en RSI",
        "checkIdentity": "Verificar sesión RSI",
        "targetGroup": "Grupo para las naves que encuentre",
        "addBundledVehicles": "Añadir snub crafts incluidas",
        "addBundledVehiclesHint": "Añade la snub craft que viene con una nave. Las que ya están en tu hangar se conservan.",
        "syncPaints": "Sincronizar pinturas",
        "syncPaintsHint": "Sustituye tus pinturas por las de tu hangar de RSI. Desactivado deja las pinturas guardadas como están.",
        "syncHangarFlair": "Sincronizar decoración de hangar",
        "syncHangarFlairHint": "Sustituye tu decoración de hangar por la de tu hangar de RSI. Desactivado deja la decoración guardada como está.",
        "syncCcus": "Sincronizar CCU",
        "syncCcusHint": "Sustituye tus CCU por los de tu hangar de RSI. Desactivado conserva los CCU guardados.",
        "syncEquipment": "Sincronizar equipo FPS",
        "syncEquipmentHint": "Sustituye tu equipo FPS por el de tu hangar de RSI. Desactivado deja el equipo guardado como está.",
        "settings": "Ajustes",
        "unmatchedVehiclesAction": "Naves que no están en tu hangar RSI",
        "unmatchedVehiclesActionHint": "Qué hacer con las naves que tienes aquí y que la sincronización no encuentra en tu lista de pledges de RSI.",
        "unmatchedHangarGroup": "Grupo en el que archivarlas",
        "unmatchedHangarGroupHint": "Las naves se dejan tal cual, solo se reúnen en este grupo para que puedas revisarlas.",
        "unmatchedVehiclesActions": {
          "wishlist": "Moverlas a la lista de deseos",
          "delete": "Eliminarlas",
          "keep": "Dejarlas sin cambios",
          "group": "Archivarlas en un grupo"
        },
        "identityStatus": {
          "pending": "Comprobando...",
          "notFound": "no encontrado",
          "connected": "conectado"
        },
        "platforms": {
          "chrome": "Google Chrome",
          "firefox": "Mozilla Firefox",
          "edge": "Microsoft Edge",
          "opera": "Opera",
          "github": "GitHub"
        },
        "pledgeItems": {
          "pages": "Páginas",
          "all": "Todos los objetos de Pledge",
          "ships": "Naves",
          "components": "Módulos",
          "upgrades": "Mejoras",
          "paints": "Pinturas",
          "hangarFlair": "Decoración de hangar",
          "paintsNotSynced": "Pinturas (no se sincronizan)",
          "hangarFlairNotSynced": "Decoración de hangar (no se sincroniza)",
          "equipment": "Equipo FPS",
          "ccus": "Mejoras / CCU",
          "ccusNotSynced": "CCU (sin sincronizar)",
          "equipmentNotSynced": "Equipo FPS (no se sincroniza)",
          "extras": "Otros objetos (se reparten entre decoración y equipo FPS)"
        },
        "importedItems": {
          "importedVehicles": "Naves agregadas",
          "foundVehicles": "Naves encontradas",
          "movedVehiclesToWanted": "Naves movidas a lista de deseos",
          "deletedVehicles": "Naves eliminadas",
          "groupedVehicles": "Naves archivadas en un grupo",
          "unchangedVehicles": "Naves sin cambios",
          "missingModels": "Naves no encontradas",
          "importedComponents": "Componentes agregados",
          "foundComponents": "Componentes encontrados",
          "missingComponents": "Componentes no encontrados",
          "missingComponentVehicles": "No se encontró nave coincidente para componentes",
          "importedUpgrades": "Mejoras agregadas",
          "foundUpgrades": "Mejoras encontradas",
          "syncedPaints": "Pinturas sincronizadas",
          "syncedHangarFlair": "Decoración de hangar sincronizada",
          "syncedCcus": "CCU sincronizados",
          "syncedEquipment": "Equipo FPS sincronizado",
          "missingUpgrades": "Mejoras no encontradas",
          "missingUpgradeVehicles": "No se encontró nave coincidente para mejoras"
        },
        "incomplete": "Algunos elementos de su hangar RSI no se pudieron leer, por lo que esta vez las naves que faltan se dejaron como estaban."
      },
      "cargoGridViewer": {
        "capacity": "Capacidad",
        "maxContainerSize": "Contenedor máx.",
        "packed": "Empaquetado",
        "totalCargo": "Carga total",
        "didNotFit": "No cabe",
        "enoughShips": "Cuatro naves llenan la grilla.",
        "addShip": "Añadir nave",
        "removeShip": "Remove",
        "autoFillShip": "Auto-fill"
      },
      "travelTimes": {
        "quantumDrive": "Motor Quantum",
        "fuelUsage": "Consumo de combustible",
        "travelTime": "Tiempo de viaje",
        "poweredBy": "basado en",
        "rank": "#",
        "size": "Tamaño",
        "grade": "Grado",
        "sizeValue": "S%{size}",
        "intro": "Cuánto tarda cada motor Quantum en tu salto — y cuánto combustible Quantum consume.",
        "jumpDistance": "Distancia de salto",
        "distanceHint": "1 Mkm es un millón de kilómetros. Cruzar Stanton son unos 40.",
        "filters": "Filtros",
        "resetFilters": "Restablecer",
        "barLegend": "La barra muestra el tiempo frente al motor más lento",
        "count": "%{count} motores",
        "countFiltered": "%{count} de %{total} motores",
        "noMatch": "Ningún motor coincide con estos filtros.",
        "presets": {
          "moon": "Salto lunar",
          "short": "Salto corto",
          "system": "Cruzar Stanton",
          "far": "Trayecto largo"
        }
      },
      "admin": {
        "importLoaders": {
          "ship_matrix_all": {
            "name": "Todo",
            "description": "Naves, módulos, pinturas, naves de préstamo y precios de naves, todo a la vez."
          },
          "ship_matrix": {
            "name": "Naves",
            "description": "Todas las naves con sus datos y la tienda, de la matriz de naves de RSI."
          },
          "modules": {
            "name": "Módulos",
            "description": "Módulos de naves de la tienda de RSI."
          },
          "paints": {
            "name": "Pinturas",
            "description": "Pinturas de la tienda de RSI."
          },
          "loaners": {
            "name": "Naves de préstamo",
            "description": "Qué naves de préstamo vienen con cada nave, de RSI."
          },
          "uex_vehicle_prices": {
            "name": "Precios de naves",
            "description": "Dónde se compran y alquilan las naves en el juego, de UEX."
          },
          "sc_data": {
            "name": "Datos del juego · %{environment}",
            "description": "Todos los catálogos de los archivos del juego: componentes, equipo, mercancías, planos, misiones y lugares."
          },
          "sc_data_models": {
            "name": "Naves de los archivos del juego",
            "description": "Solo las naves, de la versión por defecto."
          },
          "uex_commodity_prices": {
            "name": "Precios de mercancías",
            "description": "Precios y existencias de terminales, de UEX."
          },
          "uex_component_prices": {
            "name": "Precios de componentes",
            "description": "Dónde se venden los componentes, de UEX."
          },
          "uex_equipment_prices": {
            "name": "Precios de equipo",
            "description": "Dónde se vende el equipo, de UEX."
          },
          "uex_trade_routes": {
            "name": "Terminales y rutas comerciales",
            "description": "Las terminales de UEX y las rutas comerciales entre ellas."
          },
          "environments": {
            "live": "Live",
            "ptu": "PTU"
          }
        },
        "locations": {
          "parent": "Superior",
          "system": "Sistema",
          "scKey": "Clave del juego",
          "scRefs": "Referencias del juego",
          "slug": "Slug",
          "gameType": "Tipo del juego",
          "build": "Versión",
          "children": "Lugares dentro",
          "missions": "Misiones vinculadas",
          "missionTemplates": "Plantillas de misión",
          "shownWithParentOnly": "Solo visible con su superior",
          "yes": "Sí",
          "no": "No",
          "unavailable": "no disponible",
          "appearance": "Apariencia",
          "image": "Imagen",
          "color": "Color",
          "appearanceHint": "El color rellena el círculo del planeta o luna, sombreado como una esfera iluminada. Si se deja vacío, se toma de la imagen al subirla.",
          "headerImageHint": "La imagen se muestra como imagen de cabecera en la página del lugar.",
          "shops": "Tiendas",
          "shopImageHint": "La imagen se muestra como imagen de cabecera en la página de la tienda.",
          "sunHint": "El color tiñe el brillo de la estrella."
        },
        "blueprints": {
          "status": {
            "sourceKnown": "Fuente conocida",
            "outputResolved": "Resultado en un catálogo"
          },
          "columns": {
            "source": "Fuente",
            "output": "Resultado",
            "build": "Compilación",
            "created": "Creado el",
            "slot": "Ranura",
            "material": "Material",
            "type": "Tipo",
            "quantity": "Cantidad",
            "minQuality": "Calidad mínima",
            "stat": "Estadística",
            "change": "Cambio",
            "base": "Base",
            "ramp": "Progresión",
            "kind": "Tipo",
            "org": "Org",
            "mission": "Misión",
            "standing": "Reputación",
            "pool": "Grupo"
          },
          "makes": "Produce",
          "noOutput": "En ningún catálogo",
          "slug": "Slug",
          "scKey": "Clave del juego",
          "scRef": "Referencia del juego",
          "build": "Compilación",
          "state": "Estado",
          "states": {
            "current": "Actual",
            "retired": "Retirado"
          },
          "createdAt": "Creado el",
          "updatedAt": "Actualizado el"
        },
        "missions": {
          "unnamed": "Nunca nombrada por el juego",
          "slug": "Slug",
          "scKey": "Clave del juego",
          "scRef": "Ref del juego",
          "generator": "Generador",
          "debugName": "Nombre de depuración",
          "build": "Compilación",
          "difficultyAxes": "Dificultad (habilidad / carga / riesgo / conocimiento)",
          "state": "Estado",
          "states": {
            "retired": "Retirada",
            "released": "En la versión",
            "unreleased": "Fuera de la versión"
          },
          "columns": {
            "released": "En la versión",
            "generator": "Generador",
            "build": "Compilación",
            "rewardKind": "Tipo",
            "amount": "Cantidad",
            "rewardDetail": "Detalle"
          },
          "filters": {
            "debugName": "Nombre de depuración",
            "named": "Nombrada",
            "unnamed": "Nunca nombrada",
            "namedFilter": "Nombrado",
            "currentBuild": "Solo compilación actual",
            "anyBuild": "Cualquier compilación",
            "build": "Compilación"
          }
        },
        "dashboard": {
          "quickStats": {
            "onlineUsers": "Usuarios en línea"
          }
        },
        "supporterContributions": {
          "source": {
            "patreon": "Patreon",
            "kofi": "Ko-fi",
            "buymeacoffee": "Buy me a coffee",
            "paypal": "PayPal",
            "other": "Otro"
          },
          "linkedVia": {
            "patreon_account": "Cuenta de Patreon",
            "claim_key": "Token de patrocinador",
            "payer_email": "Correo del pagador",
            "manual": "Establecida por un admin"
          }
        },
        "announcements": {
          "columns": {
            "title": "Título",
            "status": "Estado",
            "deliveries": "Canales",
            "recipients": "Destinatarios",
            "publishedAt": "Enviado"
          },
          "statuses": {
            "draft": "Borrador",
            "scheduled": "Programado",
            "publishing": "Enviando",
            "published": "Enviado",
            "failed": "Fallido"
          },
          "channels": {
            "in_app": "En la app",
            "discord": "Discord",
            "bluesky": "Bluesky"
          },
          "deliveryStatuses": {
            "pending": "Pendiente",
            "succeeded": "Enviado",
            "skipped": "Omitido",
            "failed": "Fallido"
          },
          "lastTested": "Última prueba %{time}",
          "noChannel": "Seleccione al menos un canal.",
          "notifyUsersInfo": "Correo solo si lo han activado.",
          "discordPartsInfo": "Vacío: se divide automáticamente.",
          "socialPartsInfo": "Vacío: una publicación recortada. Dos o más: un hilo.",
          "recipientsCount": "%{count} destinatarios",
          "partPosition": "%{position} de %{total}",
          "deliverySummary": "%{sent}/%{total} enviados",
          "deliveryFailedCount": "%{count} fallidos",
          "deliveryPendingCount": "%{count} pendientes",
          "deliverySkippedCount": "%{count} omitidos",
          "attempts": "%{count} intentos",
          "content": "Contenido",
          "manualPostsInfo": "El texto que recibe Bluesky, para publicarlo a mano en X o en otro sitio.",
          "engagement": {
            "likes": "Me gusta",
            "reposts": "Reposts",
            "replies": "Respuestas",
            "quotes": "Citas",
            "noReactions": "Aún no hay reacciones.",
            "fetchedAt": "Actualizado %{time}",
            "notFetched": "Las cifras llegan en menos de una hora.",
            "untracked": "Publicado antes de que se registraran las reacciones."
          }
        },
        "resourceAccess": {
          "title": "Acceso a recursos",
          "groups": {
            "ship_data": "Datos de naves",
            "community": "Comunidad",
            "system": "Sistema"
          },
          "privileges": {
            "locations": "Ubicaciones",
            "blueprints": "Planos",
            "models": "Modelos",
            "model_modules": "Módulos de modelos",
            "components": "Componentes",
            "manufacturers": "Fabricantes",
            "vehicles": "Vehículos",
            "images": "Imágenes",
            "fleets": "Flotas",
            "users": "Usuarios",
            "supporters": "Patrocinadores",
            "admins": "Administradores",
            "announcements": "Anuncios",
            "oauth_applications": "Aplicaciones OAuth",
            "maintenance": "Mantenimiento",
            "imports": "Importaciones",
            "features": "Funciones",
            "workers": "Workers",
            "pghero": "PgHero",
            "rsi-api-status": "Estado de la API de RSI",
            "stats": "Estadísticas"
          }
        },
        "versions": {
          "blank": "vacío",
          "revertQuestion": "¿Revertir?",
          "sources": {
            "custom": "Admin",
            "rsi_loader": "Ship Matrix",
            "sc_data_loader": "Archivos del juego",
            "sc_loader": "Archivos del juego",
            "uex_price_sync": "Sincronización de precios UEX",
            "unknown": "Desconocido"
          }
        },
        "models": {
          "unlisted": "Sin modelo"
        }
      },
      "hangarTable": {
        "extraColumns": "Columnas",
        "columns": {
          "storeImage": "Imagen",
          "storeImageWide": "Imagen ancha",
          "angledView": "Imagen 3D",
          "angledViewWide": "Imagen 3D ancha",
          "modelManufacturerName": "Fabricante",
          "modelLength": "Longitud",
          "modelBeam": "Manga",
          "modelHeight": "Altura",
          "modelMass": "Masa",
          "modelCargo": "Carga",
          "modelCrew": "Tripulación",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "Velocidad máx.",
          "modelGroundMaxSpeed": "Velocidad terrestre",
          "modelFocus": "Enfoque",
          "modelProductionStatus": "Estado de producción",
          "modelPrice": "Precio",
          "modelPledgePrice": "Precio de Pledge"
        }
      },
      "fleetTable": {
        "extraColumns": "Columnas",
        "columns": {
          "storeImage": "Imagen",
          "storeImageWide": "Imagen ancha",
          "angledView": "Imagen 3D",
          "angledViewWide": "Imagen 3D ancha",
          "modelManufacturerName": "Fabricante",
          "modelLength": "Longitud",
          "modelBeam": "Manga",
          "modelHeight": "Altura",
          "modelMass": "Masa",
          "modelCargo": "Carga",
          "modelCrew": "Tripulación",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "Velocidad máx.",
          "modelGroundMaxSpeed": "Velocidad terrestre",
          "modelProductionStatus": "Estado de producción",
          "modelPrice": "Precio",
          "modelPledgePrice": "Precio de Pledge",
          "owner": "Propietario",
          "vehiclesCount": "Cantidad"
        }
      },
      "logistics": {
        "inventoryCount": "inventories",
        "pending": "pending",
        "entriesCount": "entries",
        "managedBy": "Managed by",
        "itemName": "Name",
        "category": "Category",
        "component": "Component",
        "componentCategory": "Component Type",
        "commodity": "Commodity",
        "commodityType": "Commodity Type",
        "equipment": "Equipment",
        "equipmentItemType": "Equipment Type",
        "quantity": "Quantity",
        "unit": "Unit",
        "notes": "Notes",
        "status": "Status",
        "requested": "Requested",
        "description": "Description",
        "priority": "Priority",
        "requestedBy": "Requested by",
        "states": {
          "draft": "Draft",
          "submitted": "Submitted",
          "rejected": "Rejected",
          "cancelled": "Cancelled"
        },
        "requestTypes": {
          "general": "General"
        },
        "priorities": {
          "standard": "Standard",
          "critical": "Critical"
        },
        "searchItems": "Search items...",
        "quality": "Quality (0-1000)",
        "qualityMin": "Quality >=",
        "qualityMax": "Quality <=",
        "existingItem": "Select existing item",
        "inventoryName": "Inventory Name",
        "visibility": "Visibility",
        "visibilities": {
          "members_only": "All Members",
          "officers_only": "Officers Only",
          "squadron_only": "Solo escuadrón"
        },
        "inventory": "Inventory",
        "notesPlaceholder": "Add notes...",
        "entryType": "Type",
        "entryTypes": {
          "deposit": "Deposit",
          "withdrawal": "Withdrawal"
        },
        "stockView": "Current Stock",
        "logView": "Transaction Log",
        "addedBy": "Logged by",
        "member": "Member",
        "selectItem": "Select item",
        "currentStock": "Available",
        "location": "Location",
        "image": "Image",
        "categories": {
          "commodity": "Commodity",
          "component": "Component",
          "weapon": "Weapon",
          "equipment": "Equipment",
          "ammunition": "Attachments & Ammunition",
          "consumable": "Consumable",
          "other": "Other"
        },
        "units": {
          "scu": "SCU",
          "units": "Units"
        },
        "csvImportHelp": "Upload a CSV file with columns: name, category, quantity, unit, notes. Download the template for the correct format.",
        "imported": "items imported",
        "importErrors": "errors",
        "inStock": "In stock",
        "entries": "Entries",
        "lastEntry": "Last entry",
        "history": "History",
        "linkedItem": "Linked item",
        "itemUnavailable": "Not in current patch",
        "itemUnavailableHint": "The current game build no longer ships this item. Entries keep it, but it cannot be picked for new ones.",
        "qualityRange": "Quality",
        "stockItem": "Stock Item",
        "overCapacity": "por encima de la capacidad de carga",
        "cargoGrid": "Rejilla de carga",
        "shipInventory": "Inventario de la nave",
        "remaining": "Restante",
        "unmeasured": "%{count} sin medir todavía",
        "transferTarget": "Destinatario",
        "transferNote": "Nota",
        "noStock": "Nada que mover",
        "overStock": "Más de lo que contiene esta posición",
        "incoming": "Entrantes",
        "outgoing": "Salientes",
        "transferStates": {
          "pending": "Pendiente",
          "completed": "Entregado",
          "declined": "Rechazado",
          "cancelled": "Cancelado",
          "expired": "Caducado"
        },
        "acceptInto": "Aceptar en",
        "reportReason": "Motivo",
        "reportReasons": {
          "spam": "Spam",
          "harassment": "Acoso",
          "scam": "Estafa",
          "other": "Otra cosa"
        },
        "transferToFleet": "%{fleet} (flota)",
        "sender": "De",
        "recipient": "Para",
        "contents": "Contenido",
        "state": "Estado",
        "sentAt": "Enviado",
        "transferKinds": {
          "inventory": "Mis inventarios",
          "fleet": "Una flota",
          "user": "Una persona",
          "mine": "Mis inventarios",
          "fleetInventories": "Esta flota",
          "contract": "Un contrato en el que trabajo"
        },
        "transferTargetKind": "Enviar a",
        "contractDeliveryTarget": "%{contract} (%{fleet}): %{destination}",
        "transferFromFleet": "De la flota",
        "noTransferTargets": "Aquí no hay destino",
        "recordedAt": "Registrado",
        "origin": "De / A",
        "inTransitAmount": "%{amount} en tránsito",
        "inTransitHint": "Enviado en una transferencia que nadie ha respondido. Ya está fuera de los totales.",
        "transferFromFriends": "Mis amigos",
        "towardsContract": "Para un contrato",
        "noContract": "Ningún contrato",
        "forContract": "para",
        "openInCatalogue": "Abrir en el catálogo"
      },
      "hangarInventories": "Inventories",
      "adminNotifications": {
        "inbox": "Bandeja de entrada",
        "archive": "Archivo",
        "unreadOnly": "Solo no leídas",
        "status": "Estado",
        "severity": "Gravedad",
        "type": "Tipo",
        "selectPrompt": "Selecciona una notificación para leerla",
        "noBody": "Esta notificación no incluye más detalles.",
        "lastSeen": "Vista por última vez",
        "expires": "Caduca",
        "severities": {
          "info": "Info",
          "warning": "Aviso",
          "error": "Error"
        },
        "types": {
          "paints_import": "Importación de pinturas",
          "modules_import": "Importación de módulos",
          "loaner_sync": "Sincronización de naves prestadas",
          "uex_prices_import": "Sincronización de precios UEX",
          "uex_commodity_prices_import": "Sincronización de materias primas UEX",
          "uex_component_prices_import": "Sincronización de componentes UEX",
          "uex_equipment_prices_import": "Sincronización de equipamiento UEX",
          "uex_trade_routes_sync": "Sincronización de rutas comerciales UEX",
          "new_supporter": "Nuevo patrocinador",
          "rsi_api_blocked": "API de RSI bloqueada",
          "rsi_api_unblocked": "API de RSI restaurada",
          "rsi_markup_changed": "Página de RSI cambiada",
          "weekly_stats": "Informe semanal",
          "ship_matrix_import": "Importación de Ship Matrix",
          "sc_data_import": "Importación de sc_data",
          "sc_data_unlisted_models": "Naves no listadas",
          "import_run": "Importación",
          "oauth_application_review": "Revisión de aplicación OAuth",
          "inventory_transfer_reports": "Transferencias de inventario denunciadas"
        }
      },
      "optional": "opcional",
      "notificationActions": {
        "open": "Abrir",
        "openHangar": "Abrir hangar",
        "openModel": "Ver nave",
        "openInvite": "Ver invitación",
        "reviewRequest": "Revisar solicitud",
        "openMembers": "Ver miembros",
        "openFleet": "Abrir flota",
        "openInventory": "Abrir inventario",
        "openEvent": "Abrir evento",
        "openRoster": "Ver inscripciones",
        "addToCalendar": "Añadir al calendario",
        "openStore": "Tienda de pledges",
        "accept": "Aceptar",
        "decline": "Rechazar",
        "signUp": "Inscribirse",
        "withdraw": "Retirarse",
        "syncAgain": "Sincronizar de nuevo",
        "markAsBought": "Marcar como comprada",
        "unavailable": "Esto ya no está disponible.",
        "openTransfers": "Abrir transferencias",
        "openFriends": "Abrir amigos",
        "openAllies": "Abrir aliados",
        "openTour": "Abrir expedición",
        "openSquadron": "Abrir escuadrón",
        "openContract": "Abrir contrato",
        "openPayouts": "Abrir pagos"
      },
      "notificationTypes": {
        "channels": {
          "app": "App",
          "mail": "Correo",
          "push": "Push",
          "discord": "Discord"
        },
        "groups": {
          "account": "Cuenta y hangar",
          "announcements": "Anuncios",
          "fleetMembership": "Membresía de flota",
          "fleetEvents": "Eventos de flota",
          "logistics": "Logística",
          "relationships": "Amigos y aliados",
          "tours": "Expediciones",
          "fleetContracts": "Contratos de flota"
        },
        "announcement": "Anuncio",
        "hangar_sync_finished": "Sincronización del hangar finalizada",
        "hangar_sync_failed": "Sincronización del hangar fallida",
        "model_on_sale": "Modelo en oferta",
        "new_model": "Nuevo modelo lanzado",
        "fleet_invite": "Invitación de flota recibida",
        "fleet_member_requested": "Membresía solicitada",
        "fleet_member_accepted": "Membresía aceptada",
        "fleet_request_accepted": "Solicitud de ingreso aceptada",
        "fleet_joined_by_discord_role": "Ingreso mediante rol de Discord",
        "fleet_inventory_item_added": "Objeto añadido al inventario de la flota",
        "fleet_event_published": "Evento publicado",
        "fleet_event_locked": "Inscripciones del evento bloqueadas",
        "fleet_event_starting_soon": "El evento empieza pronto",
        "fleet_event_started": "Evento iniciado",
        "fleet_event_completed": "Evento completado",
        "fleet_event_cancelled": "Evento cancelado",
        "fleet_event_signup_added": "Nueva inscripción",
        "fleet_event_signup_withdrawn": "Inscripción retirada",
        "fleet_event_signup_confirmed": "Inscripción confirmada",
        "fleet_event_signup_assigned": "Asignado a un slot",
        "fleet_event_signup_kicked": "Eliminado de un slot",
        "allInGroup": "Todo en este grupo",
        "inventory_transfer_received": "Transferencia recibida",
        "inventory_transfer_resolved": "Transferencia respondida",
        "friend_request_received": "Solicitud de amistad recibida",
        "friend_request_accepted": "Solicitud de amistad aceptada",
        "fleet_ally_request_received": "Solicitud de alianza recibida",
        "fleet_ally_request_accepted": "Solicitud de alianza aceptada",
        "tour_join_request_received": "Solicitud de participación recibida",
        "tour_join_request_accepted": "Solicitud de participación aceptada",
        "fleet_squadron_request_received": "Solicitud para unirse al escuadrón",
        "fleet_squadron_request_accepted": "Solicitud de escuadrón aceptada",
        "fleet_contract_published": "Contrato publicado",
        "fleet_announcement_posted": "Anuncio publicado",
        "fleet_contract_claimed": "Contrato aceptado",
        "fleet_contract_crew_requested": "Alguien quiere unirse a un contrato",
        "fleet_contract_crew_answered": "Solicitud de tripulación respondida",
        "fleet_subscription_started": "Funciones de flota activadas",
        "fleet_subscription_ended": "Funciones de flota perdidas",
        "fleet_fid_claim_opened": "ID de flota reclamado",
        "fleet_fid_claim_completed": "ID de flota transferido",
        "fleet_fid_claim_cancelled": "Reclamación de ID de flota terminada",
        "fleet_rsi_verification_lost": "Verificación de flota perdida",
        "rsi_handle_verification_lost": "Verificación del handle de RSI perdida",
        "fleet_contract_fulfilled": "Contrato cumplido",
        "fleet_contract_settled": "Contrato pagado",
        "payout_ledger_settled": "Pagos cerrados",
        "payout_entry_pending_review": "Gasto pendiente de revisión",
        "payout_entry_declined": "Gasto rechazado",
        "fleet_verification_requested": "Tu flota solicita una verificación"
      },
      "fleets": {
        "missions": {
          "untitled": "Misión sin título",
          "title": "Título",
          "description": "Descripción",
          "team": "Equipo",
          "teams": "Equipos",
          "ship": "Nave",
          "ships": "Naves",
          "slot": "Slot",
          "slots": "Slots",
          "noMissions": "Aún no hay misiones.",
          "noTeams": "Aún no se han añadido equipos.",
          "noShips": "Aún no se han añadido naves.",
          "noSlots": "Aún no se han añadido slots.",
          "archivedTab": "Archivadas",
          "activeTab": "Activas",
          "archived": "Archivada",
          "modelSpecific": "Nave específica",
          "modelList": "Cualquiera de estas",
          "modelListHint": "El puesto admite cualquiera de las naves que elijas.",
          "allowedShips": "Naves que encajan",
          "anyOf": "Cualquiera de",
          "filterRange": "Rango de filtro",
          "classification": "Clasificación",
          "focus": "Enfoque",
          "minSize": "Tamaño mín.",
          "maxSize": "Tamaño máx.",
          "minCrew": "Tripulación mín.",
          "minCrewOverride": "Anular",
          "minCrewOverrideLabel": "Anulación de tripulación mín.",
          "minCrewOverrideHint": "Déjalo vacío para usar la tripulación de la nave.",
          "minCargo": "Carga mín. (SCU)",
          "createdBy": "Creada por",
          "seats": "Asientos",
          "category": "Categoría",
          "coverImage": "Imagen de portada",
          "scenario": "Escenario",
          "categories": {
            "other": "Otras",
            "ship_combat": "Combate de naves",
            "ground_combat": "Combate terrestre",
            "combined_combat": "Combate combinado",
            "mining": "Minería",
            "salvage": "Salvamento",
            "cargo_hauling": "Transporte de carga",
            "exploration": "Exploración"
          }
        },
        "events": {
          "untitled": "Evento sin título",
          "title": "Título",
          "description": "Descripción",
          "briefing": "Briefing",
          "startsAt": "Empieza el",
          "endsAt": "Termina el",
          "timezone": "Zona horaria",
          "location": "Ubicación del evento",
          "meetupLocation": "Punto de encuentro",
          "visibility": "Visibilidad",
          "maxAttendees": "Asistentes máx.",
          "autoLockEnabled": "Bloquear inscripciones automáticamente",
          "autoLockMinutesBefore": "Minutos antes del inicio para bloquear",
          "recurring": "Se repite",
          "recurringHint": "Genera este evento automáticamente con una periodicidad fija. Los miembros se inscriben en cada repetición.",
          "recurringSummary": "Se repite %{interval}",
          "recurringUntil": "Se repite %{interval} hasta %{date}",
          "recurringForCount": "Se repite %{interval} (%{count} repeticiones)",
          "viewSeries": "Ver serie",
          "recurrenceInterval": "Repetir cada",
          "recurrenceEnd": "Termina",
          "recurrenceEndNever": "Nunca",
          "recurrenceEndOn": "En una fecha",
          "recurrenceEndAfter": "Después de",
          "recurrenceEndOccurrences": "repeticiones",
          "recurrenceUnit": {
            "daily": "días",
            "weekly": "semanas",
            "monthly": "meses"
          },
          "recurrenceWeekdays": "Los días",
          "recurrenceWeekdaysHint": "El día en que empieza el evento siempre está incluido.",
          "recurrence": {
            "daily": "a diario",
            "weekly": "semanalmente",
            "monthly": "mensualmente",
            "everyN": {
              "daily": "cada %{count} días",
              "weekly": "cada %{count} semanas",
              "monthly": "cada %{count} meses"
            },
            "onDays": "%{interval} (%{days})"
          },
          "occurrencesSection": "Próximas repeticiones",
          "skipOccurrence": "Omitir esta repetición",
          "overrideOccurrence": "Anular la repetición del %{date}",
          "overrideOccurrenceShort": "Editar solo esta",
          "overrideOccurrenceHint": "Anula campos solo para esta repetición. Déjalos en blanco para heredarlos del evento recurrente.",
          "endSeriesHere": "Detener a partir de aquí",
          "splitSeriesHere": "Editar esta y las siguientes",
          "splitSeriesConfirm": "¿Continuar la serie desde esta fecha como un evento nuevo? Las inscripciones de esta fecha y las posteriores pasan al nuevo evento, que se abre para editarlo.",
          "excludedBadge": "Omitida",
          "noUpcomingOccurrences": "No hay repeticiones próximas en las siguientes 12 semanas.",
          "endSeriesConfirm": "¿Detener la repetición después de esta fecha? No se generarán repeticiones futuras.",
          "skipOccurrenceSuccess": "Repetición omitida.",
          "unskipOccurrence": "Restaurar esta repetición",
          "unskipOccurrenceSuccess": "Repetición restaurada.",
          "endSeriesSuccess": "Serie finalizada a partir de esta fecha.",
          "cancelledReason": "Motivo de la cancelación",
          "createdBy": "Creado por",
          "signups": "Inscripciones",
          "signupsCount": "%{count} inscripciones",
          "youAreHere": "Estás aquí",
          "attendance": "Asistencia",
          "signupsLockedHint": "Las inscripciones están bloqueadas para este evento.",
          "alreadySignedUpHint": "Ya estás inscrito en otro slot. Retírate primero para cambiar.",
          "slotTakenHint": "Este slot ya está ocupado.",
          "currentSlot": "Slot actual",
          "currentSlotHint": "Este es el slot en el que está actualmente la inscripción.",
          "takenBy": "Ocupado por %{username}",
          "slotPickerHint": "Elige un slot para esta inscripción. Los slots ya ocupados o no disponibles están deshabilitados.",
          "signupCtaHint": "Inscríbete en el evento — puedes elegir un slot concreto ahora o dejar que un administrador te asigne uno más tarde.",
          "noSlotYet": "Sin slot todavía",
          "signupApproval": "Aprobación de inscripciones",
          "signupStatuses": {
            "confirmed": "Confirmada",
            "tentative": "Tentativa",
            "interested": "Interesado",
            "pending": "Pendiente de aprobación",
            "withdrawn": "Retirada"
          },
          "signupApprovals": {
            "direct": "Directa",
            "confirmation_required": "Requiere confirmación"
          },
          "unassignedSignupsHint": "Estos miembros se inscribieron en el evento pero aún no tienen slot. Asígnales uno abajo o elimina la inscripción.",
          "taken": "Ocupado",
          "grantedRoles": "Roles concedidos",
          "noEventAdminsYet": "Aún no hay administradores ni moderadores adicionales.",
          "creator": "Creador del evento",
          "eventTeamHint": "Concede a otros miembros derechos de administrador o moderador para este evento. Los administradores pueden editarlo y los moderadores pueden gestionar las inscripciones.",
          "eventRole": "Rol",
          "eventRoles": {
            "admin": "Administrador",
            "moderator": "Moderador"
          },
          "memberPicker": "Miembro",
          "spawnedEvents": "Eventos generados",
          "fromMission": "De la misión",
          "pickTemplate": "Elegir una plantilla",
          "pickTemplateHint": "Opcionalmente, parte de una misión — sus datos, equipos, naves y slots se copian al evento, que queda vinculado a ella.",
          "noTemplate": "Sin plantilla",
          "noTemplateHint": "Crea el evento desde cero.",
          "pickTemplateLoadFailed": "No se pudieron cargar las misiones de la flota.",
          "pickTemplatePageFailed": "No se pudieron cargar las siguientes misiones.",
          "pickTemplateSearch": "Buscar misiones",
          "pickTemplateNonePublished": "Ninguna misión activa de la flota está publicada todavía.",
          "pickTemplateNoneActive": "La flota no tiene misiones activas.",
          "pickTemplateNoMatch": "Ninguna misión publicada coincide con la búsqueda.",
          "changeTemplate": "Cambiar plantilla",
          "clearTemplate": "Quitar plantilla",
          "myVehicle": "Mi vehículo",
          "selectVehicle": "Seleccionar un vehículo (opcional)",
          "vehicleMismatchHint": "El vehículo seleccionado no cumple los requisitos de este slot.",
          "noFittingInHangar": "Nada de tu hangar encaja en este slot. Aun así puedes inscribirte dejando el vehículo vacío.",
          "vehicleFitsHint": "Aporta un vehículo que encaja con esta nave.",
          "notes": "Notas",
          "upcomingTab": "Próximos",
          "pastTab": "Pasados",
          "archivedTab": "Archivados",
          "listTab": "Lista",
          "calendarTab": "Calendario",
          "subscribeHint": "Copia la URL del feed del calendario a tu portapapeles para que puedas pegarla en tu aplicación de calendario.",
          "visibilities": {
            "members": "Miembros",
            "officers": "Oficiales",
            "fleet": "Público",
            "squadron": "Solo escuadrón"
          },
          "statuses": {
            "draft": "Borrador",
            "open": "Abierto a inscripciones",
            "locked": "Inscripciones bloqueadas",
            "active": "En directo",
            "completed": "Completado",
            "cancelled": "Cancelado",
            "past": "Pasado"
          },
          "tabs": {
            "basic": "Información básica",
            "description": "Descripción y portada",
            "teams": "Equipos y naves",
            "overview": "Resumen",
            "settings": "Ajustes"
          },
          "calendar": {
            "month": "Mes",
            "week": "Semana",
            "weekTitle": "Semana del %{date}"
          },
          "repeats": "Se repite"
        },
        "contracts": {
          "tabs": {
            "details": "Detalles",
            "delivery": "Entrega",
            "crew": "Tripulación y recompensa",
            "goods": "Mercancías"
          },
          "title": "Título",
          "description": "Descripción",
          "reward": "Recompensa",
          "deadline": "Fecha límite",
          "crewLimit": "Límite de tripulación",
          "visibility": "Visibilidad",
          "visibilities": {
            "members_only": "Todos los miembros",
            "squadron_only": "Solo escuadrón"
          },
          "reimburseExpenses": "Reembolsar gastos",
          "from": "Recoger en",
          "to": "Entregar en",
          "toHint": "Las entregas en uno de tus propios inventarios se te envían a ti, y tú mismo las aceptas.",
          "toAuthorHint": "Las entregas van a %{username}, que las acepta.",
          "myHangarInventory": "%{name} (mi hangar)",
          "authorHangarInventory": "%{name} (hangar de %{username})",
          "destinationRemoved": "Ya no está disponible",
          "lead": "Responsable",
          "pendingCrew": "Esperando unirse",
          "minQuality": "calidad mín. %{value}",
          "pickedUp": "%{quantity} recogido",
          "itemName": "Artículo",
          "itemCategory": "Categoría",
          "itemUnit": "Unidad",
          "itemQuantity": "Cantidad",
          "kind": {
            "label": "Tipo",
            "transport": "Transporte",
            "procurement": "Adquisición",
            "crafting": "Fabricación"
          },
          "state": {
            "draft": "Borrador",
            "open": "Abierto",
            "in_progress": "En curso",
            "fulfilled": "Completado",
            "cancelled": "Cancelado",
            "expired": "Caducado",
            "settled": "Liquidado"
          },
          "itemTypes": {
            "Commodity": "Mercancía",
            "Component": "Componente",
            "Equipment": "Equipo"
          },
          "qualityMatch": "Coincidencia",
          "exactQuality": "exactamente %{value}",
          "qualityMatches": {
            "at_least": "Al menos",
            "exact": "Exactamente"
          },
          "itemQuality": "Calidad",
          "titleHint": "Opcional: sin título, el contrato toma el nombre de las mercancías que pide",
          "postedBy": "Publicado por",
          "claimedBy": "aceptado por",
          "delivered": "Entregado",
          "deliveredOf": "%{delivered} / %{requested} %{unit}",
          "views": {
            "open": "Abiertos",
            "closed": "Cerrados",
            "mine": "Míos",
            "completed": "Completados"
          }
        }
      },
      "commodity": {
        "name": "Nombre",
        "buyPrice": "Compra",
        "sellPrice": "Venta",
        "retired": "Ya no está en la compilación actual",
        "containerSizes": "Tamaños de contenedor (SCU)",
        "pieceVolume": "Volumen por pieza (SCU)",
        "consumable": "Consumible",
        "refinesInto": "Se refina en",
        "refinedFrom": "Se refina a partir de",
        "availability": {
          "retired": "Los precios se registran para la versión en la que está el catálogo, y esta mercancía no aparece en ella.",
          "craftedOnly": "Ninguna terminal la comercia — es un material de fabricación.",
          "none": "Ninguna terminal que conozcamos compra ni vende esto."
        },
        "chart": {
          "buyHighest": "Compra, máxima",
          "buyAverage": "Compra, media",
          "buyLowest": "Compra, mínima",
          "sellHighest": "Venta, máxima",
          "sellAverage": "Venta, media",
          "sellLowest": "Venta, mínima"
        },
        "types": {
          "agricultural_supply": "Suministros agrícolas",
          "alloy": "Aleaciones",
          "consumer_goods": "Bienes de consumo",
          "drink": "Bebidas",
          "food": "Alimentos",
          "gas": "Gases",
          "hpmc": "HPMC",
          "manmade": "Artificial",
          "medical_supply": "Suministros médicos",
          "metal": "Metales",
          "military_supply": "Suministros militares",
          "mineral": "Minerales",
          "natural": "Natural",
          "nonmetals": "No metales",
          "plasma_fuel": "Combustible de plasma",
          "processed_goods": "Bienes procesados",
          "quantum_fuel": "Combustible cuántico",
          "rmc": "RMC",
          "scrap": "Chatarra",
          "vice": "Vicio",
          "waste": "Residuos"
        },
        "commodityType": "Commodity Type",
        "uexId": "UEX ID",
        "uexCode": "UEX Code",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "equipment": {
        "equipmentType": "Tipo de equipo",
        "itemType": "Tipo de objeto",
        "subType": "Subtipo",
        "weaponClass": "Clase de arma",
        "slot": "Ranura",
        "size": "Tamaño",
        "grade": "Grado",
        "hidden": "Hidden?",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image",
        "name": "Nombre",
        "manufacturer": "Fabricante",
        "retired": "Ya no está en la compilación actual",
        "noMetrics": "No hay métricas registradas para este objeto.",
        "availability": {
          "retired": "Los precios se registran para la versión en la que está el catálogo, y este objeto no está en ella.",
          "craftedOnly": "Ninguna terminal lo vende: se fabrica con la receta de abajo.",
          "none": "Ninguna terminal lo compra ni lo vende."
        },
        "stats": {
          "damageReduction": "Reducción de daño",
          "temperatureRating": "Rango de temperatura",
          "radiationProtection": "Protección contra radiación",
          "radiationScrubRate": "Tasa de depuración de radiación",
          "gForceTolerance": "Tolerancia a la fuerza G",
          "carryingCapacity": "Capacidad de carga",
          "magazineSize": "Capacidad del cargador",
          "rateOfFire": "Cadencia de fuego",
          "range": "Alcance efectivo",
          "weaponClass": "Clase de arma",
          "coreCompatibility": "Compatibilidad de núcleo",
          "backpackCompatibility": "Compatibilidad de mochila",
          "volume": "Volumen"
        },
        "sorts": {
          "damageReduction": "Reducción de daño",
          "radiationProtection": "Protección contra radiación",
          "gForceTolerance": "Tolerancia a la fuerza G",
          "rateOfFire": "Cadencia de fuego",
          "range": "Alcance",
          "storage": "Capacidad",
          "volume": "Volumen"
        }
      },
      "notifications": {
        "inbox": "Bandeja de entrada",
        "archive": "Archivo",
        "unreadOnly": "Solo no leídas",
        "status": "Estado",
        "type": "Tipo",
        "selectPrompt": "Selecciona una notificación para leerla",
        "noBody": "Esta notificación no incluye más detalles.",
        "archivesOn": "Se mueve al archivo",
        "deletesOn": "Se elimina"
      },
      "unlistedModel": {
        "linkHint": "¿Qué nave del catálogo es %{identifier}? La sugerencia viene del export y puede estar equivocada."
      },
      "slug": "Slug",
      "inventories": {
        "source": "Fuente",
        "sources": {
          "vehicle": "Nave",
          "handMade": "Creado a mano"
        }
      },
      "inventoryItems": {
        "name": "Nombre",
        "category": "Categoría",
        "entryType": "Movimiento",
        "quantity": "Cantidad",
        "quality": "Calidad",
        "notes": "Notas",
        "itemType": "Catálogo",
        "categories": {
          "commodity": "Mercancía",
          "component": "Componente",
          "weapon": "Arma",
          "equipment": "Equipamiento",
          "ammunition": "Munición",
          "consumable": "Consumible",
          "other": "Otros"
        },
        "entryTypes": {
          "deposit": "Depósito",
          "withdrawal": "Retirada"
        },
        "units": {
          "scu": "SCU",
          "units": "unidades"
        }
      },
      "shipHistory": {
        "sales": "Historial de ofertas",
        "salesCount": "Ofertas registradas",
        "lastSale": "Última oferta",
        "averageGap": "Intervalo medio",
        "days": "%{count} días",
        "ongoing": "En curso",
        "priceHistory": "Historial de precio pledge",
        "firstPriced": "Primer precio",
        "priceRemoved": "Precio retirado",
        "wishlist": "Adiciones a la lista de deseos por mes",
        "patchChanges": "Cambios del parche",
        "notRecordedYet": "Solo se registra desde que empezó el seguimiento, así que una nave puede no tener nada."
      },
      "buildCompare": {
        "from": "Desde la compilación",
        "to": "Hasta la compilación",
        "appeared": "Nuevos",
        "vanished": "Desaparecidos",
        "changed": "Modificados",
        "notRecorded": "No registrado para una de estas compilaciones.",
        "needsTwoBuilds": "Solo hay una compilación registrada, así que no hay nada con que compararla.",
        "pickTwoBuilds": "Elige dos compilaciones distintas.",
        "failed": "No se han podido comparar estas dos compilaciones.",
        "andMore": "y %{count} más",
        "catalogues": {
          "components": "Componentes",
          "equipment": "Equipamiento",
          "commodities": "Mercancías",
          "models": "Naves"
        }
      },
      "dockAccess": {
        "ramp": "Rampa",
        "lift": "Elevador",
        "tractor_beam": "Rayo tractor"
      },
      "dockTypes": {
        "vehiclepad": "Plataforma de vehículos",
        "garage": "Garaje",
        "landingpad": "Plataforma de aterrizaje",
        "dockingport": "Puerto de atraque",
        "hangar": "Hangar",
        "cargogrid": "Rejilla de carga"
      },
      "shipSizes": {
        "extra_extra_small": "Snubcraft (XXS)",
        "extra_small": "Extra pequeño (XS)",
        "small": "Pequeño (S)",
        "medium": "Mediano (M)",
        "large": "Grande (L)",
        "extra_large": "Extra grande (XL)",
        "capital": "Capital (C)"
      },
      "payouts": {
        "currency": "Moneda",
        "archived": "Archivada",
        "activeTours": "Actuales",
        "amount": "Importe",
        "description": "Descripción",
        "entryType": "Tipo",
        "expense": "Gastado",
        "income": "Ganado",
        "participant": "Quién",
        "notes": "Notas",
        "occurredAt": "Cuándo",
        "paid": "Gastado",
        "held": "Tiene",
        "share": "Parte",
        "net": "Saldo",
        "profit": "Beneficio",
        "totalIncome": "Ganado",
        "totalExpenses": "Gastado",
        "guest": "Invitado",
        "username": "Usuario",
        "name": "Nombre",
        "sends": "envía",
        "receives": "recibe",
        "settled": "Liquidado",
        "open": "Abierto",
        "owes": "debe",
        "isOwed": "se le debe",
        "even": "en paz",
        "title": "Título",
        "fleet": "Flota",
        "startsAt": "Comienza el",
        "inviteLink": "Enlace de invitación",
        "participants": "Personas",
        "weight": "Peso",
        "shares": "partes",
        "customWeight": "Peso personalizado",
        "preview": "Vista previa · cambia hasta liquidar",
        "joinRequestPending": "Solicitud pendiente",
        "payer": "Pagador",
        "declineReason": "Motivo",
        "review": {
          "pending": "Pendiente de revisión",
          "approved": "Aprobado",
          "declined": "Rechazado"
        }
      },
      "relationships": {
        "party": "Nombre",
        "since": "Desde",
        "tabs": {
          "accepted": "Activos",
          "incoming": "Entrantes",
          "outgoing": "Enviadas",
          "ignored": "Ignoradas"
        },
        "user": {
          "handle": "Nombre de usuario"
        },
        "fleet": {
          "handle": "Identificador de la flota"
        },
        "requested": "Solicitud enviada",
        "friend": "Amigos"
      },
      "blueprint": {
        "name": "Nombre",
        "craftTime": "Tiempo de fabricación",
        "slots": "Ranuras",
        "materials": "Materiales",
        "quality": "Calidad",
        "missionSlots": {
          "location": "lugar",
          "objects": "objetos",
          "target": "objetivo",
          "ship": "nave",
          "cargo": "carga",
          "rank": "rango",
          "danger": "peligro",
          "contract": "contrato",
          "other": "variable"
        },
        "missionSlotsHint": "Los términos entre ‹comillas angulares› los completa el juego cuando se ofrece el contrato.",
        "atNeutral": "%{value} en Q500",
        "whatYouGet": "Lo que obtienes",
        "fromSlots": "%{count} ranuras",
        "factorOnly": "solo factor — sin valor de catálogo",
        "heldIn": "en",
        "heldOn": "en",
        "fromHangar": "Hangar",
        "makes": "Produce",
        "makesA": "Receta de fabricación · produce",
        "makesUnknown": "Receta de fabricación · produce algo que no figura en ningún catálogo",
        "retired": "Retirado",
        "minQuality": "Mín. %{quality}",
        "belowGate": "Por debajo del umbral de esta ranura — el material inferior a %{quality} no cabe aquí.",
        "unvalued": "afectado — el juego no indica valores",
        "noStats": "Esta ranura no mueve ninguna estadística — basta con que el material esté.",
        "noMaterials": "Los archivos del juego no indican materiales para esta receta.",
        "setEverySlot": "Ajustar todas las ranuras",
        "qualityAll": "todas las ranuras en %{quality}",
        "qualityRange": "%{from}–%{to} entre las ranuras",
        "anyOf": "Cualquiera %{count} de estas %{total}",
        "scu": "%{amount} SCU",
        "pieces": "%{count}×",
        "whereItDrops": "Dónde se consigue",
        "fleetOwners": "Quién puede fabricarlo",
        "ownedByCount": "%{count} lo tienen",
        "sourceSummary": "%{count} fuentes · %{orgs} organizaciones",
        "unattributed": "Sin atribuir",
        "minPoints": "Desde %{points} puntos",
        "noKnownSource": "Sin fuente conocida",
        "noSourceLead": "Ninguna misión ni escenario entrega esta receta.",
        "noSourceBody": "Los archivos del juego no la incluyen en ningún grupo de recompensas, así que no hay nada que señalar.",
        "empty": "No hay planos que coincidan.",
        "craftableTypes": {
          "Component": "Componente",
          "Equipment": "Equipo",
          "Commodity": "Mercancía"
        },
        "alignments": {
          "lawful": "Legal",
          "neutral": "Neutral",
          "outlaw": "Forajido"
        },
        "kinds": {
          "contract": "Contrato",
          "scenario": "Escenario"
        },
        "duration": {
          "hours": "%{count} h",
          "minutes": "%{count} min",
          "seconds": "%{count} s"
        }
      },
      "gameMission": {
        "locationNamedInText": "mencionado en la sesión informativa",
        "locations": "Dónde tiene lugar",
        "locationKinds": {
          "surface": "En un planeta o luna",
          "space": "En el espacio",
          "mixed": "Planeta, luna o espacio",
          "unknown": "Ubicación desconocida"
        },
        "location": "Ubicación",
        "cannotLand": {
          "surface": "%{ship} no puede aterrizar: este contrato es en un planeta o luna",
          "mixed": "Puede llevar a %{ship} a un planeta o luna, donde no puede aterrizar"
        },
        "calculatedInGame": "Calculado en el juego",
        "blueprints": "Planos",
        "name": "Nombre",
        "org": "Ofrecida por",
        "offeredBy": "Ofrecida por",
        "offeredByUnknown": "Sin contratista indicado",
        "standing": "Reputación",
        "kind": "Tipo",
        "kinds": {
          "career": "Carrera",
          "contract": "Puntual"
        },
        "difficulty": "Dificultad",
        "difficultyAxes": {
          "mechanicalSkill": "Habilidad mecánica",
          "mentalLoad": "Carga mental",
          "riskOfLoss": "Riesgo de pérdida",
          "gameKnowledge": "Conocimiento del juego"
        },
        "alignments": {
          "lawful": "Legal",
          "neutral": "Neutral",
          "outlaw": "Forajido"
        },
        "rewards": "Recompensas",
        "rewardKinds": {
          "blueprint": "Planos",
          "reputation": "Reputación",
          "item": "Objetos",
          "badge": "Insignia",
          "currency": "Pago"
        },
        "oneOfASet": "uno de un conjunto",
        "briefing": "Instrucciones",
        "templatedNote": "El juego rellena las partes marcadas cuando entrega la misión.",
        "payoutNote": "El juego calcula el pago al generar la misión, por eso los archivos solo indican uno para unos pocos contratos.",
        "noRewards": "Los archivos no indican ninguna recompensa para esta misión.",
        "unreleased": "Fuera de la versión",
        "retired": "Retirada"
      },
      "fleetDirectory": {
        "name": "Flotas",
        "memberCount": "Miembros",
        "createdAt": "Más recientes",
        "language": "Idioma",
        "recruiting": "Reclutando",
        "notRecruiting": "No recluta",
        "roleplay": "Rol",
        "rsiSid": "SID %{sid}"
      },
      "tour": {
        "step": "Paso %{current} de %{total}"
      },
      "vehiclePlaque": {
        "style": "Estilo",
        "styles": {
          "brass": "Latón",
          "hud": "HUD de Fleetyards",
          "gunmetal": "Metal de cañón",
          "blueprint": "Plano de astillero",
          "salvage": "Chatarra remachada",
          "glass": "Vidrio esmerilado",
          "carbon": "Carbono y rojo señal",
          "walnut": "Nogal y latón",
          "neon": "Neón de Pyro",
          "manufacturer": "Estilo del fabricante"
        },
        "captain": "Capitán",
        "captainInfo": "Déjalo vacío para que aparezca tu nombre tal como se muestra en tu hangar público.",
        "registry": "Matrícula",
        "operationsGroup": "Equipo de operaciones",
        "title": "Placa de dedicatoria",
        "dedication": "Dedicatoria",
        "dedicationVerse": "Verso de dedicatoria",
        "dedicationVerseInfo": "Opcional. Unos versos o una bendición que se muestran al pasar el cursor sobre la dedicatoria o tocarla.",
        "launchedOn": "Fecha de botadura",
        "launchPort": "Puerto de botadura",
        "affiliation": "Afiliación"
      },
      "vehicleOverview": {
        "picture": "Imagen",
        "pictureInfo": "Se muestra en lugar de la imagen por defecto, también en tu hangar público y en las flotas con las que compartes esta nave.",
        "ownPicture": "Tu imagen",
        "serial": "Número de serie %{serial}",
        "since": "En el hangar desde %{date}",
        "logSummary": "%{count} entradas · %{public} públicas",
        "cargoFill": "%{stowed} de %{capacity} SCU cargados",
        "cargoStowed": "%{stowed} SCU cargados",
        "cargoMeter": "Carga",
        "configuration": "Configuración",
        "noPaint": "Pintura estándar",
        "ownedPaints": "Tus pinturas",
        "availablePaints": "Pinturas",
        "ownedPaintsCount": {
          "one": "%{count} pintura",
          "other": "%{count} pinturas"
        },
        "visibility": "Visibilidad",
        "showPublic": "Mostrar en mi hangar público",
        "showName": "Mostrar el nombre",
        "fleets": "Al servicio de",
        "status": "Estado",
        "searchPaints": "Buscar pinturas",
        "location": "Ubicación",
        "noLocation": "Sin indicar",
        "noGroups": "Sin grupos",
        "planLoadout": "Planificar un loadout",
        "pictureUpload": "Subir",
        "pictureGallery": "Galería",
        "stockPicture": "Imagen estándar",
        "waysToGetIt": "Cómo conseguirla"
      },
      "vehicleLog": {
        "entries": "entradas de bitácora",
        "title": "Título",
        "loggedAt": "Fecha",
        "loggedAtPlaceholder": "Ahora",
        "body": "Entrada",
        "public": "Mostrar en mi hangar público",
        "publicShort": "Pública",
        "publicByDefault": "Las entradas nuevas son públicas",
        "filters": {
          "all": "Todas",
          "public": "Públicas",
          "private": "Privadas"
        },
        "entryCount": {
          "one": "%{count} entrada",
          "other": "%{count} entradas"
        },
        "privateShort": "Privada",
        "stats": "El cuaderno",
        "statsEntries": "Entradas",
        "statsPublic": "Públicas",
        "statsSince": "Desde"
      },
      "vehicleEdit": {
        "tabs": {
          "general": "General",
          "visibility": "Visibilidad",
          "notifications": "Notificaciones",
          "names": "Nombres",
          "groups": "Grupos",
          "picture": "Imagen"
        }
      },
      "vehicleLoadout": {
        "tabs": {
          "paints": "Pinturas",
          "modules": "Módulos",
          "upgrades": "Complementos",
          "weapons": "Armas",
          "missiles": "Misiles",
          "shields": "Generadores de escudo",
          "powerPlants": "Plantas de energía",
          "coolers": "Enfriadores",
          "quantumDrives": "Motores Quantum",
          "radar": "Radar",
          "lifeSupport": "Soporte vital",
          "flightBlades": "Blades de vuelo"
        },
        "comingSoon": "Próximamente",
        "ownedModules": "Tus módulos",
        "nothingFitted": "Nada equipado",
        "owned": "En propiedad",
        "noSlots": "Todavía no se puede equipar nada de esta nave aquí",
        "unavailableModule": "Módulo ya no disponible",
        "noFigureChange": "No cambia ninguna cifra de la nave",
        "loadoutName": "Nombre de la configuración",
        "stock": "De serie",
        "notFlightReady": "Las configuraciones solo están disponibles para naves listas para volar",
        "slots": {
          "default": "Ranura de módulo",
          "front": "Ranura de módulo delantera",
          "rear": "Ranura de módulo trasera",
          "left": "Ranura de módulo izquierda",
          "right": "Ranura de módulo derecha"
        },
        "unavailable": {
          "modules": "Esta nave no admite módulos",
          "upgrades": "No hay complementos para esta nave"
        },
        "none": "Ninguno"
      },
      "loadoutPicker": {
        "emptySocket": "Vacío",
        "search": "Buscar",
        "owned": "En propiedad",
        "stock": "De serie",
        "manufacturer": "Fabricante",
        "sortName": "Nombre",
        "count": "%{count} de %{total}",
        "total": {
          "one": "%{count} opción",
          "other": "%{count} opciones"
        },
        "reset": "Restablecer filtros",
        "leaveEmpty": "Dejar vacío",
        "noMatches": "Sin resultados",
        "close": "Cerrar"
      }
    }
  }
}
